<template>
  <div :style="screenHeight" v-if="screenColumn.showForm">
    <div  :style="screenWidth"
         style="height: 99%;float: left;box-shadow: 3px 3px 10px #9c9c9c;overflow-y: auto;position: relative;padding-left:20px;">
      <Spin size="large" fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>正在加载中...</div>
      </Spin>
      <el-tabs v-model="tabsName" @tab-click="changeTabsName">
        <el-tab-pane  class="telephone_screen public_pop" label="客户基本信息" name="infor1">
          <div class="screen_title" style="margin-top:30px">
            <div class="customer_info_png">
              <img src="../../assets/image/customerInfo.png"/>
              <div style="line-height: 28px;margin-left: 10px">
                <span>客户基本信息</span>
                <a href="javascript:void(0)" @click="handleOpenForCust">
                  <Icon type="ios-arrow-up" v-if="visible"></Icon>
                  <Icon type="ios-arrow-down" v-else></Icon>
                </a>
              </div>
            </div>
            <Select v-model="customerId" placeholder="请选择客户名称" :disabled="screenColumn.isChangeCustomer"
                    v-if="screenColumn.customerList.length>1" class="phone_selected"
                    @on-change="changeCustomerFun(customerId)" style="margin-right:20px">
              <Option v-for="(option, index) in screenColumn.customerList" :value="option.id" :key="index">
                {{option.customerName}}
              </Option>
            </Select>
            <Tooltip v-if="screenColumn.customerList.length>1" class="tips_font" placement="top"
                     content="该号码已被系统中多个用户使用"><img :src="questionMark"/></Tooltip>
            <div style="margin-left: 200px;padding-top: 3px;"><span v-if="pstnNumber">热线号码:{{pstnNumber}}</span><span
              style="padding-left: 20px;" v-if="collectionData">采集信息:{{collectionData}}</span></div>
          </div>
          <Form ref="screenColumn" v-if="screenColumn.showForm" label-colon class="form_submit_pop"
                :show-message="showMessage" :model="screenColumn" :rules="screenColumn.customerRule"
                style="height: 300px;overflow: auto">
            <FormItem :label="item.customName" :title="item.customName" :prop="item.customColName"
                      v-for="(item,index) in screenColumn.columnList"
                      v-if="item.customColName!='createTime' && item.customColName!='lastConnectTime' && item.customColName!='allocateTime' && item.customColName!='shareTime' && item.customColName!='shareStatus' && item.customColName!='creator' && item.customColName!='status'"
                      :key="index" :class="{'teleFormStyle':item.type=='file' || item.type=='textarea'}">

              <Input v-if="item.type=='text' " v-model="item.customValue" :disabled="item.customIsAlter!='1'"/>

              <Input v-if="item.type == 'textarea'" type="textarea" :rows="3" v-model="item.customValue"
                     :disabled="item.customIsAlter!='1'"/>

              <div class="phone_note" title="发送短信" v-if="item.customColName.indexOf('telephone')!=-1"
                   @click="sendNoteInfo(item.customOrigin)"><img src="../../assets/image/note.png"/></div>
              <div class="phone_note" title="拨打电话" v-if="item.customColName.indexOf('telephone')!=-1"
                   @click="callPhone(item.customOrigin)"><img src="../../assets/image/phone.png"/></div>

              <el-date-picker v-model="item.customValue" type="datetime" :title="item.customName" align="left"
                              :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                              v-if="item.type=='datetime'"></el-date-picker>
              <div class="phone_note" v-if="item.type=='datetime'"><img src="../../assets/image/timeIcon.png"/></div>
              <Select v-if="item.type=='select' || item.type=='radio'" :transfer="true" clearable
                      v-model="item.customValue" :disabled="item.customIsAlter!='1'">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                </Option>
              </Select>
              <Select v-if="item.type=='checkbox'" clearable multiple :transfer="true" :max-tag-count="3"
                      v-model="item.customValue" :disabled="item.customIsAlter!='1'">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                </Option>
              </Select>
              <el-cascader clearable v-if="item.type=='cascade'" v-model="item.customValue"
                           :placeholder="item.customName" :title="item.customName" :options="item.list"
                           :props="{ expandTrigger: 'hover' }"></el-cascader>
              <Input v-if="item.type=='number'" type="number" title="只能输入数字" v-model="item.customValue"
                     :disabled="item.customIsAlter!='1'"/>
              <File v-if="item.type=='file'" v-model="item.customValue" :disabled="item.customIsAlter!='1'"
                    style="width:98%" @fileUploadCallback="fileUploadCallback" :showFilelist="true"/>
            </FormItem>
            <FormItem :label="item.customName" :title="item.customName" v-show="isShow" :prop="item.customColName"
                      v-for="(item,index) in screenColumn.isShowList"
                      v-if="item.customColName!='createTime' && item.customColName!='lastConnectTime' && item.customColName!='allocateTime' && item.customColName!='shareTime' && item.customColName!='shareStatus' && item.customColName!='creator' && item.customColName!='status'"
                      :key="screenColumn.columnList.length+index"
                      :class="{'teleFormStyle':item.type=='file' || item.type=='textarea'}">

              <Input v-if="item.type=='text'" v-model="item.customValue" :disabled="item.customIsAlter!='1'"/>
              <div class="phone_note" title="发送短信" v-if="item.customColName.indexOf('telephone')!=-1"
                   @click="sendNoteInfo(item.customOrigin)"><img src="../../assets/image/note.png"/></div>
              <div class="phone_note" title="拨打电话" v-if="item.customColName.indexOf('telephone')!=-1"
                   @click="callPhone(item.customOrigin)"><img src="../../assets/image/phone.png"/></div>
              <Input v-if="item.type == 'textarea'" type="textarea" :rows="3" v-model="item.customValue"
                     :disabled="item.customIsAlter!='1'"/>
              <el-date-picker v-model="item.customValue" type="datetime" :title="item.customName" align="left"
                              :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                              v-if="item.type=='datetime'"></el-date-picker>
              <div class="phone_note" v-if="item.type=='datetime'"><img src="../../assets/image/timeIcon.png"/></div>
              <Select v-if="item.type=='select' || item.type=='radio'" :transfer="true" clearable
                      v-model="item.customValue" :disabled="item.customIsAlter!='1'">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                </Option>
              </Select>
              <Select v-if="item.type=='checkbox'" clearable multiple :transfer="true" :max-tag-count="3"
                      v-model="item.customValue" :disabled="item.customIsAlter!='1'">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                </Option>
              </Select>
              <el-cascader clearable v-if="item.type=='cascade'" v-model="item.customValue"
                           :placeholder="item.customName" :title="item.customName" :options="item.list"
                           :props="{ expandTrigger: 'hover' }"></el-cascader>
              <Input v-if="item.type=='number'" type="number" title="只能输入数字" v-model="item.customValue"
                     :disabled="item.customIsAlter!='1'"/>
              <File v-if="item.type=='file'" v-model="item.customValue" @fileUploadCallback="fileUploadCallback" :disabled="item.customIsAlter!='1'"
                    style="width:98%" :showFilelist="true"/>
            </FormItem>
          </Form>
          <Tabs v-model="tabName" :class="{'tabName_style':tabName=='name1'}" @on-click="clickChangeTabs">
            <TabPane label="服务信息" v-if="'0' == configInfo.isHiddenService" name="name1">
              <Form ref="screenColumn" v-if="screenColumn.showForm" label-colon class="form_submit_pop"
                    :show-message="showMessage" :model="screenColumn" :rules="screenColumn.serviceRule">
                <FormItem :label="item.customName"
                          v-if="item.customColName!='customerId' && item.customColName!='employeeId' && item.customColName!='serviceNextTime' && item.customColName!='createTime'"
                          :prop="item.customColName" v-for="(item,index) in screenColumn.serviceList" :key="index"
                          :class="{'teleFormStyle':item.type=='file' || item.type=='textarea'}">
                  <Input v-if="item.type=='text'" v-model="item.customValue" :disabled="item.customIsAlter!='1'"/>
                  <Input v-if="item.type=='textarea'" type="textarea" :rows="3" v-model="item.customValue"
                         :disabled="item.customIsAlter!='1'"/>
                  <el-date-picker v-model="item.customValue" type="datetime" :title="item.customName" align="left"
                                  :editable="editable" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                                  v-if="item.type=='datetime'"></el-date-picker>
                  <div class="phone_note" v-if="item.type=='datetime'"><img src="../../assets/image/timeIcon.png"/>
                  </div>
                  <Select v-if="item.type=='select' || item.type=='radio'" :transfer="true" clearable
                          v-model="item.customValue" >
                    <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                    </Option>
                  </Select>
                  <Select v-if="item.type=='checkbox'" clearable multiple :transfer="true" :max-tag-count="3"
                          v-model="item.customValue" :disabled="item.customIsAlter!='1'">
                    <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                    </Option>
                  </Select>
                  <el-cascader clearable v-if="item.type=='cascade'" v-model="item.customValue"
                               :placeholder="item.customName" :title="item.customName" :options="item.list"
                               :props="{ expandTrigger: 'hover' }"></el-cascader>
                  <Input v-if="item.type=='number'" type="number" title="只能输入数字" v-model="item.customValue"
                         :disabled="item.customIsAlter!='1'"/>
                  <File v-if="item.type=='file'" v-model="item.customValue" :disabled="item.customIsAlter!='1'"
                        style="width:98%;" @fileUploadCallback="fileUploadCallback" :showFilelist="true"/>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="历史服务记录" v-if="'0' == configInfo.isHiddenService" name="name2">
              <div>
                <el-table :data="ServiceRecordList" class="element_table" :class="{'tableClass':tableClass}" stripe
                          ref="selection" @selection-change="getSelectedId">
                  <el-table-column v-for="(item,index) in serviceFieldList" align="center" :show-overflow-tooltip='true'
                                   :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key"
                                   :label="item.title" :width="item.width">
                    <template slot="header" slot-scope="scope">
                      <el-tooltip placement="top">
                        <span
                          style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;width: 100%;display: block;">{{item.title}}</span>
                        <div slot="content">
                          <span>{{item.title}}</span>
                        </div>
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <!-- 附件 -->
                      <el-tooltip placement="top" effect="light"
                                  v-if="item.key != undefined && item.key.indexOf('file') != -1 && scope.row[item.key] != '' && scope.row[item.key] != undefined">

                        <span style="color: #2d8cf0;" v-if="JSON.parse(scope.row[item.key]).length > 0">共{{JSON.parse(scope.row[item.key]).length}}个附件</span>
                        <div slot="content">
                          <p v-for="(fileItem,fileIndex) in JSON.parse(scope.row[item.key])" :key="fileIndex">
                            <a style="font-size:14px;color: rgb(0, 0, 255)"
                               :href="baseURL+'common/downloadFile.json?type=0&addr='+fileItem.downloadAddr">附件{{fileIndex+1}}：{{fileItem.description}}</a>
                          </p>
                        </div>
                      </el-tooltip>
                      <!-- 其他 -->
                      <span v-else>{{scope.row[item.key]}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" v-if="ServiceRecordList.length>0" width="150"
                                   align="center">
                    <template slot-scope="scope">
                      <el-button v-if="roleList['1_5-5']" @click="searchServiceRecordDetail(scope.row.id)" type="text"
                                 size="small">详情
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="page_style" >
                <Page :total="total" size="small" :page-size='pageSize' :current='currentPage'
                      :page-size-opts="pageSizeList" show-total show-sizer @on-change="changeCurrent"
                      @on-page-size-change="changeSize"/>
                <div style="padding-top: 2px;">跳至</div>
                <Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/>
                <div style="padding-top: 2px;">页</div>
              </div>
            </TabPane>
            <!--add history-->
            <TabPane label="来电交互轨迹" name="name3">
              
                <el-collapse v-model="activeNames">
                  <template v-for="(item,index) in interactions">
                    <el-collapse-item :title="item.name+ ' ' + item.startTime" :name="item.startTime + ' ' + item.name"
                                      :key="`IVR`+index" v-if="item.type==='IVR'">
                      <div style="padding: 0 10px">
                        <!--<ul>
                          <li v-for="(item,index) in item.content" :key="index" class="ivr_li"><span>{{item.intime}}</span><span>{{item.remark}}</span></li>
                        </ul>-->
                        <el-timeline-item :timestamp="nitem.intime" placement="top"
                                          v-for="(nitem,index) in item.content" :key="index">
                          <el-card>
                            <h4>{{nitem.remark}}</h4>
                          </el-card>
                        </el-timeline-item>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item :title="item.name+ ' ' + item.startTime" :name="item.startTime + ' ' + item.name"
                                      :key="`CHAT`+index" v-else-if="item.type==='CHAT'">
                      
                          <chatList style="height:533px"
                            :list="item.content"
                            @click="bindEvent"
                            @loadHistory="loadHistoryHandler"
                            :config="chatListConfig"/>
                        
                    </el-collapse-item>
                  </template>
                </el-collapse>
              
            </TabPane>
          </Tabs>
        </el-tab-pane>
        <el-tab-pane v-if="'1' == sysSupportWorkOrder" class="work_order_screen" label="工单信息" name="infor2" style="overflow:hidden;">
          <div class="wotab" :style="wolistWidth"
               style="float:left;border:1px solid #e9e9e9;border-bottom:1px solid transparent">
            <el-tabs type="border-card" v-model="wotype" :style="heightStyleForLeft">
              <el-tab-pane label="新建工单" name="1" style="width:100%;">
                <div style="margin-top:15px;"></div>
                <div v-for="(option,indexOne) in fileData" style="margin-top:12px;margin-left:5px;margin-right:5px;margin-top:5px">
                  <div>
                    <p style="width:100%;border:1px solid #bbd9fb;"></p>
                    <p style="z-index:2;margin-top:-10px;margin-left:10px;background:white;width: max-content;">&ensp;
                      <span style="width: 100px;overflow: hidden;">{{option.groupName}}</span>
                      <img @click="showOrHideGroup(indexOne)" v-if="'1' == showHideList[indexOne]"
                           src="@/assets/image/workOrder/closeIcon.png"/>
                      <img @click="showOrHideGroup(indexOne)" v-if="'0' == showHideList[indexOne]"
                           src="@/assets/image/workOrder/Openicon.png"/>
                    </p>
                  </div>
                  <!--  -->
                  <div style="padding:9px 10px 10px 10px">
                    <div style="position:relative;">
                      <Form ref="addEditColumn" v-if="'1' == showHideList[indexOne]" label-colon class="form_submit_pop"
                            :show-message="false"
                            :model="fileData.fieldList" :rules="ruleValidate">
                        <FormItem :label="item.customName" :prop="item.customColName" :title="item.customName" v-if="('add'==addOrEdit && item.customColName!='createTime' && item.customColName!='lastConnectTime' && item.customColName!='allocateTime'
        && item.customColName!='shareTime' && item.customColName!='shareStatus' && item.customColName!='creator' && item.customColName!='status' && item.customColName!='orderTheme' && item.customColName!='orderDescribe') || ('edit'==addOrEdit && item.customColName!='orderTheme' && item.customColName!='orderDescribe')"
                                  v-for="(item,index) in option.allColumnInfo"
                                  :key="index">
                          <Input v-if="item.type=='text' && item.customColName!='customerName' && item.customColName!='customerPhone'" v-model="item.popCustomValue"
                                 :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit" @on-blur="editWorkOrder($event,item,indexOne,index,'','','','telephoneScreen')"/>

                          <Input v-if="item.customColName=='customerName' || item.customColName=='customerPhone'" v-model="item.popCustomValue" readonly
                                 @on-focus="getCustomerInfo" disabled/>

                          <Input v-if="item.type=='textarea'" type="textarea" :rows="3" v-model="item.popCustomValue"
                                 :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit" @on-blur="editWorkOrder($event,item,indexOne,index,'','','','telephoneScreen')"/>

                          <DatePicker type="datetime" v-if="item.type=='datetime'" :confirm="true"
                                      :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit"
                                      format="yyyy-MM-dd HH:mm:ss" placement="bottom-start"
                                      @on-change="editWorkOrder($event,item,indexOne,index,'','','','telephoneScreen')"
                                      v-model="item.popCustomValue"></DatePicker>
                          <Select
                            v-if="(item.type=='select' || item.type=='radio') && item.customColName!='customerName' && item.customColName!='orderHandler'"
                            ref="clearSingleSelect"
                            :clearable="item.customIsSystem != '1'" v-model="item.popCustomValue"
                            @on-change="editWorkOrder($event,item,indexOne,index,'','','','telephoneScreen')"
                            :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit">
                            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                            </Option>
                          </Select>

                          <el-select v-if="item.customColName=='orderHandler'"
                                     ref="clearSingleSelect" filterable
                                     :clearable="item.customIsSystem != '1'" v-model="item.popCustomValue"
                                     @change="editOrderHandler($event,item,indexOne,index)"
                                     :disabled="(item.customIsAlter!='1' || editHandle) && 'edit' == addOrEdit">
                            <el-option-group label="工单服务组">
                              <el-option v-for="(option, index) in item.list[0].serviceGroup" :label="option.dictValue" :value="option.id" :key="index"></el-option>
                            </el-option-group>
                            <el-option-group label="员工">
                              <el-option v-for="(option, index) in item.list[0].employeeGroup" :label="option.dictValue" :value="option.id" :key="index"></el-option>
                            </el-option-group>
                          </el-select>

                          <Select v-if="item.type=='checkbox' && item.customColName!='copyEmpId'" :clearable="item.customIsSystem != '1'" multiple
                                  :max-tag-count="2" @on-change="editWorkOrder($event,item,indexOne,index,'','','','telephoneScreen')"
                                  v-model="item.popCustomValue" :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit" ref="clearSingleSelect">
                            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}
                            </Option>
                          </Select>

                          <Select v-if="item.customColName=='copyEmpId'" :clearable="item.customIsSystem != '1'" multiple filterable
                                  :max-tag-count="2" @on-change="editWorkOrder($event,item,indexOne,index,'','','','telephoneScreen')"
                                  v-model="item.popCustomValue" :disabled="(item.customIsAlter!='1' || editCopyId) && 'edit' == addOrEdit" ref="clearSingleSelect">
                            <OptionGroup label="工单服务组">
                              <Option v-for="(option, index) in item.list[0].serviceGroup" :value="option.id" :key="index">{{option.dictValue}}</Option>
                            </OptionGroup>
                            <OptionGroup label="员工">
                              <Option v-for="(option, index) in item.list[0].employeeGroup" :value="option.id" :key="index">{{option.dictValue}}</Option>
                            </OptionGroup>
                          </Select>

                          <el-cascader v-if="item.type=='cascade'" v-model="item.popCustomValue" :placeholder="item.customName"
                                       ref="clearSingleSelect" @change="editWorkOrder($event,item,indexOne,index,'','','','telephoneScreen')"
                                       :clearable="item.customIsSystem == '1'" :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit"
                                       :title="item.customName"
                                       :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

                          <Input v-if="item.type=='number'" type="number" title="只能输入数字" v-model="item.popCustomValue"
                                 :disabled="(item.customIsAlter!='1' || editTable) && 'edit' == addOrEdit" @on-blur="editWorkOrder($event,item,indexOne,index,'','','','telephoneScreen')"/>

                          <File v-if="item.type=='file'" :editTable="editTable" @fileUploadCallback="fileUploadCallback" :addOrEdit="addOrEdit" v-model="item.popCustomValue" :showFilelist="true"
                                @changeFile="changeFile(item,indexOne,index)"/>
                        </FormItem>
                      </Form>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="历史工单" name="2" style="width:100%;">
                <div style="height: 90%">
                  <!-- 一行 -->
                  <ul style="list-style: none;">
                    <li style="padding:10px 0 10px 25px;border-bottom: rgb(218, 226, 251) 1px solid" v-for="(item,index) in historyList" :key="index"
                        :class="{historyactive:currentIndex === index}" @click="liClick(item,index)">
                      <div style="display:flex;align-items:center;justify-content: flex-start;line-hight:3">
                        <p style="color:black;margin-right:10px;white-space: nowrap">#{{item.id}}</p>
                        <p style="margin-right:5px;width:15px;height:15px;text-align:center;line-height: 17px;color: white;white-space: nowrap"
                           :style="setStyleColor(item.dictDescr)">
                          {{getShortValue(item.dictDescr)}}
                        </p>
                        <p style="margin-right:10px;white-space: nowrap" class="staifont" :style="setFontColor(item.dictDescr)">
                          {{item.orderState}}</p>
                        <p style="color:black;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.orderTheme}}</p>
                      </div>
                      <div style="display:flex;align-items: flex-start;justify-content: flex-start;line-hight:3">
                        <p style="color:#151414;margin-right:10px">{{item.createTime}}</p>
                      </div>
                    </li>
                  </ul>
                  <!--  -->
                </div>
              </el-tab-pane>
            </el-tabs>
            <div v-show="wotype == '2'" class="page_style" style="width: 85%;">
              <Page :total="hisTotal" size="small" :page-size='hisPageSize' :current='hisCurrentPage' show-total @on-change="hisChangeCurrent"  @on-page-size-change="hisChangeSize"/>
            </div>
          </div>
          <div :style="woconWidth" style="float:right;box-shadow: 3px 3px 10px #9c9c9c;">
            <a style="display: none;" href="javascript:void(0)" id='hiddenPop'></a>
            <div v-show="'add' == addOrEdit && wotype == '1'" style="padding-top:15px;padding-left:4%" :style="heightStyle">
              <div>
                <p style="color:#298bee;display:inline-block;margin-right:15px"><span style="color: red">*</span>{{orderTheme.customName}}:</p>
                <Input v-model="orderTheme.popCustomValue" :placeholder="'输入工单'+orderTheme.customName" style="display:inline-block;width:85%"/>
              </div>
              <div style="display:flex;align-items: flex-start;margin-top:20px">
                <p style="color:#298bee;margin-right:17px"><span style="color: red">*</span>{{orderDescribe.customName}}:</p>
                <div style="width:85%">
                  <div style="background-color:#eeeeee;width:100%;padding:5px 0 5px 15px;">
                    <Checkbox v-model="isSecret" style="color:#a1a1a1;margin-right:20px">私密回复</Checkbox>
                    <Poptip placement="top" transfer>
                      <img src="@/assets/image/workOrder/Expressicon.png"/>
                      <div slot="content">
                        <div v-for="(item, index) in emojiList" :key="index">
                          <img :src="emotion.emoji" v-for="(emotion,key) in item" :key="key" :title="emotion.descr"
                               @click="clickHandler(emotion)"/>
                        </div>
                      </div>
                      <span style="color: #a1a1a1;margin-right:20px;font-size:14px">表情</span>
                    </Poptip>

                    <Upload :action="baseUploadUrl" :on-error="uploadFail" :max-size="15360"
                            :before-upload="handleBeforeUpload" :on-success="(res,file)=>onSuccess(res,file)"
                            :on-exceeded-size="handleMaxSize" :show-upload-list="showUploadList"
                            style="display:inline-block">

                      <img src="@/assets/image/workOrder/Uploadicon.png"/>
                      <span style="color: #a1a1a1;font-size:14px">上传附件</span>
                    </Upload>
                  </div>
                  <p v-if="'add' == addOrEdit && wotype == '1'"  v-model="showAddInput.text" class="edittext" contenteditable="true" ref="editDiv" placeholder='请在此输入信息("#"搜索快捷回复)'
                     style="border: 1px solid #dae2fb;margin-top:0px;padding: 4px 7px;"
                     @blur="showInput('2')" @input="telInputChange" :class="{'editTextOne':isSecret}"></p>
                  <p v-if="telReplyFlag" style="border: 1px solid #dae2fb;margin-top:10px;position: absolute;width: 56.3%;z-index:100;" id="replyDiv">
                      <Table :columns="telReplyColumns" :data="telReplyData" :show-header="false" max-height="125" :stripe="false"
                      no-data-text="没有快捷回复内容" @on-row-click="telOnRowClick"></Table>
                  </p>
                  <div style="float:right;margin-top:50px;max-width: 400px;max-height: 250px;overflow: auto">
                    <Upload id="uploadTwo" :action="baseUploadUrl" :default-file-list="uploadList" show-upload-list
                            :on-remove="(file,fileList)=>removeFile(file,fileList)"></Upload>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="wotype == '2' && historywoList && historywoList.length>0" :style="heightStyle">
              <div style="height: 100%;padding: 20px 20px 0px 20px;" v-for="(item, index) in historywoList" :key="index">
                <div class="rightOneTop" style="height: auto" >
                  <div v-if="historywoList && historywoList.length>0" style="height:35px;display:flex;align-items: center;justify-content: space-between;margin-bottom:6px">
                    <div style="display:flex;align-items: center;">
                      <p :title="item.staffName" style="color:#f39c35;border:1px solid #f39c35;padding:5px 10px;margin-right:25px;max-width: 300px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" @click="openDetail(item.staffId,item.staffName)">
                        {{item.staffName}}</p>
                      <p style="margin-right:5px;"><img src="@/assets/image/workOrder/womesicon1.png"/></p>
                      <p style="margin-right:10px;font-size: 14px;">#{{item.staffId}}</p>
                      <p v-if="item.contentList.dictDescr"
                        style="background-color:#04c343;width:15px;height:15px;line-height:16px;text-align:center;color: white"
                        :style="{'background':item.contentList.dictDescr.color ? item.contentList.dictDescr.color:'white'}">{{item.contentList.dictDescr.shortValue}}</p>
                      <p v-if="item.contentList.dictDescr" style="color:#04c343;margin-right:10px;margin-left:5px;font-size: 14px;"
                         :style="{'color':item.contentList.dictDescr.color ? item.contentList.dictDescr.color:'white'}">
                        {{item.staffState}}</p>
                    </div>
                    <div>
                    </div>
                  </div>
                  <div style="height:25px;display:flex;align-items: center;justify-content: flex-start;margin-bottom:2px;overflow: hidden">
                    <p style="color:#9ea19f;margin-right:3px;display: flex;align-items: center;">
                      <img src="@/assets/image/workOrder/timeOutRed.png" v-show="item.contentList.showSlaImg == '1'"/>
                      <img src="@/assets/image/workOrder/timeOutGreen.png" v-show="item.contentList.showSlaImg == '2'"/>
                    </p>
                    <p style="color:#9ea19f;margin-right:10px;display: flex;align-items: center;white-space: nowrap" v-html="item.contentList.slaTime" :style="item.contentList.showColorForSla">
                    </p>
                    <p v-show="item.contentList.slaKpi" style="white-space: nowrap;color:#fcfefd;background-color:#a0a0a0;margin-right:10px;padding:0px 5px">SLA指标</p>
                    <p :title="item.contentList.slaKpi" style="color:#9ea19f;margin-right:10px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.contentList.slaKpi}}</p>
                  </div>
                  <div style="height:25px;display:flex;align-items: center;justify-content: flex-start;margin-bottom:2px;overflow: hidden">
                    <p style="color:#9ea19f;margin-right:5px;white-space: nowrap" title="创建时间">{{item.contentList.createTime}}</p>
                    <p style="color:#9ea19f;margin-left:5px;">|</p>
                    <p style="color:#9ea19f;margin-left:5px;margin-right:5px;white-space: nowrap" title="客户名称">{{item.contentList.customerName}}</p>
                    <p style="white-space: nowrap"><span>&lt;</span>
                      <span><img src="@/assets/image/workOrder/womesicon3.png"/></span>
                      <a href="javascript:void(0)" style="color:#2d8bef"  @click="messageOrPhone(item.contentList.customerPhone)" title="手机号码">{{configInfo.phoneIsHide == '1'?item.contentList.customerPhoneHide:item.contentList.customerPhone}}</a>
                      <span style="margin-left:5px;"></span>
                      <span>&gt;</span>
                    </p>
                    <p v-show="item.contentList.serviceGroup" style="color:#9ea19f;margin-left:5px;margin-right:5px;">|</p>
                    <p v-show="item.contentList.serviceGroup" title="工单服务组" style="color:#9ea19f;white-space: nowrap">&lt;<span>{{item.contentList.serviceGroup}}</span>&gt;
                    </p>
                    <p v-show="item.contentList.orderHandler" style="color:#9ea19f;margin-left:5px;margin-right:5px;">|</p>
                    <p v-show="item.contentList.orderHandler" :title="'工单处理人:'+item.contentList.orderHandler" style="color:#9ea19f;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">&lt;<span>{{item.contentList.orderHandler}}</span>&gt;
                    </p>
                  </div>
                  <div class="replymo" v-if="selscene" style="height:130px;width:100%;position:relative;">
                    <div style="height:30px;background-color:#eeeeee;width:100%;padding:5px 0 5px 15px;">
                      <Checkbox v-model="isSecret" style="color:#a1a1a1;margin-right:20px">私密回复</Checkbox>
                      <Poptip placement="top" transfer>
                        <img src="@/assets/image/workOrder/Expressicon.png"/>
                        <div slot="content">
                          <div v-for="(item, index) in emojiList" :key="index">
                            <img :src="emotion.emoji" v-for="(emotion,key) in item" :key="key" :title="emotion.descr"
                                 @click="clickHandler(emotion,'his')"/>
                          </div>
                        </div>
                        <span style="color: #a1a1a1;margin-right:20px;font-size:14px">表情</span>
                      </Poptip>
                      <Upload :action="baseUploadUrl" :on-error="uploadFail" :max-size="15360"
                              :before-upload="handleBeforeUpload" :on-success="(res,file)=>onSuccess(res,file)"
                              :on-exceeded-size="handleMaxSize" :show-upload-list="showUploadList"
                              style="display:inline-block">
                        <img src="@/assets/image/workOrder/Uploadicon.png"/>
                        <span style="color: #a1a1a1;font-size:14px">上传附件</span>
                      </Upload>

                    </div>
                    <p class="edittext" contenteditable="true" ref="editDivHistory" placeholder='请在此输入信息("#"搜索快捷回复)'
                       style="border: 1px solid #dae2fb;margin-top:0px;padding: 4px 7px;height:100px;"
                       @blur="showInput('2')" @input="telInputChange" :class="{'editTextOne':isSecret}"></p>

                    <p v-if="telReplyFlag" style="border: 1px solid #dae2fb;margin-top:10px;position: absolute;width: 100%;z-index:100;" id="replyDiv">
                      <Table :columns="telReplyColumns" :data="telReplyData" :show-header="false" max-height="125" :stripe="false"
                      no-data-text="没有快捷回复内容" @on-row-click="telOnRowClick"></Table>
                    </p>
                    <el-dropdown split-button type="primary" v-if="selscene" @click="dropClickHis(selscene,index,'telephoneScreen')"
                                 style="width:150px;position:absolute;right:25px;bottom:-45px">
                      {{selscene}}
                      <el-dropdown-menu slot="dropdown">
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div v-if="selscene" style="width: 68%;height: 50px;overflow: auto">
                    <Upload id="uploadTwo" :action="baseUploadUrl" :default-file-list="uploadList" show-upload-list
                            :on-remove="(file,fileList)=>removeFile(file,fileList)"></Upload>
                  </div>

                </div>
                <div class="rightOneButtom"
                     :style="historyBottom">
                  <div v-for="(option,indexFlow) in item.flowList" :key="indexFlow" style="margin-bottom: 20px;">
                    <!-- 客户 -->
                    <div v-if="!option.tip && '0' == option.isAgent"
                         style="display:flex;align-items: flex-start;justify-content: flex-start;width: 95%;">
                      <div style="margin-right:10px">
                        <img src="@/assets/image/workOrder/wocus.png"/>
                      </div>
                      <div style="max-width: 90%;">
                        <div>
                          <p style="display:inline-block;color:#e49149">{{option.agentNumber}}</p>
                          <p style="display:inline-block;color:#e49149">{{option.msgTime}}</p>
                        </div>
                        <div>
                          <div style="float: left;max-width: 90%;" class="editTextThree">
                            <p style="color:#7d7d7c;word-break: break-all;" v-html="replaceMsg(option.content)"></p>
                            <div v-for="(item,indexFile) in option.fileAddr" :key="indexFile">
                              <el-image v-if="item.type && item.type.indexOf('image') != -1"
                                        style="width: 100px; height: 100px" :src="baseImgURL + item.url"
                                        :preview-src-list="(baseImgURL + item.url).split('{yuneasy}')"
                                        fit="contain"></el-image>
                              <div v-else
                                   style="margin-bottom: 10px;width: 150px;height: 68px;padding: 8px 13px;border: #b8b1b1 1px solid;background-color: white">
                                <p :title="item.name"
                                   style="width: 100%;font-size: 12px;height: 16px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: 700;">
                                  {{item.name}}</p>
                                <div style="width: 100%;font-size: 12px;height: 30px;">
                                  <div style="width: 70%;font-size: 12px;height: 100%;float: left">
                                    <img style="width: 30px;height: 30px;" title="附件"
                                         src="@/assets/image/workOrder/download.png">
                                  </div>
                                  <div
                                    style="width: 30%;font-size: 12px;height: 100%;float: right;text-align: right;display: flex;align-items: flex-end;">
                                    <a :href="baseURL+'common/downloadFile.json?type=0&addr='+item.url"
                                       style="color: blue">下载</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 客服 -->
                    <div @mousemove="showImgForHistory('1',index,indexFlow)" @mouseleave="showImgForHistory('2',index,indexFlow)"
                         v-if="!option.tip && '1' == option.isAgent"
                         style="display:flex;align-items: flex-start;justify-content: flex-start;width: 95%;">
                      <div
                        style=" width:38px;height:38px; border-radius: 50%;position:relative;margin-right:10px;border:1px solid #1d82fe">
                        <img v-if="option.employeeHead"
                             style="border-radius: 50%;  border-radius:50%;width:36px;height:36px;margin-left:10px;position:absolute;left:50%;top:50%;margin-left:-18px;margin-top:-18px "
                             :src="baseImgURL+option.employeeHead"/>
                        <img v-if="!option.employeeHead"
                             style="border-radius: 50%;  border-radius:50%;width:36px;height:36px;margin-left:10px;position:absolute;left:50%;top:50%;margin-left:-18px;margin-top:-18px "
                             src="@/assets/image/customerService.png"/>
                      </div>
                      <div style="max-width: 90%;">
                        <div>
                          <p style="display:inline-block;color:#1d82fe">{{option.agentNumber}}</p>
                          <p style="display:inline-block;color:#1d82fe">{{option.msgTime}}</p>
                        </div>
                        <div style="float: left;max-width: 90%;" class="editTextFour">
                          <p style="color:#7d7d7c;word-break: break-all;" v-html="replaceMsg(option.content)"></p>
                          <div v-for="(item,indexFile) in option.fileAddr" :key="indexFile">
                            <el-image v-if="item.type && item.type.indexOf('image') != -1" style="width: 100px; height: 100px"
                                      :src="baseImgURL + item.url"
                                      :preview-src-list="(baseImgURL + item.url).split('{yuneasy}')" fit="contain"></el-image>
                            <div v-else
                                 style="margin-bottom: 10px;width: 150px;height: 68px;padding: 8px 13px;border: #b8b1b1 1px solid;background-color: white">
                              <p :title="item.name"
                                 style="width: 100%;font-size: 12px;height: 16px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: 700;">
                                {{item.name}}</p>
                              <div style="width: 100%;font-size: 12px;height: 30px;">
                                <div style="width: 70%;font-size: 12px;height: 100%;float: left">
                                  <img style="width: 30px;height: 30px;" title="附件"
                                       src="@/assets/image/workOrder/download.png">
                                </div>
                                <div
                                  style="width: 30%;font-size: 12px;height: 100%;float: right;text-align: right;display: flex;align-items: flex-end;">
                                  <a :href="baseURL+'common/downloadFile.json?type=0&addr='+item.url"
                                     style="color: blue">下载</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="width: 23px;height: 23px;float: left">
                          <img title="私密信息" src="@/assets/image/workOrder/lock.png" v-if="option.isSecret == '1'"
                               @click="changeSecretHistory(option,index,indexFlow,'telephoneScreen')">
                          <img title="公开信息" src="@/assets/image/workOrder/unlock.png"
                               v-if="option.showImg && option.isSecret == '0'" @click="changeSecretHistory(option,index,indexFlow,'telephoneScreen')">
                        </div>
                      </div>
                    </div>
                    <!--tip提示-->
                    <div v-if="option.tip" style="display:flex;align-items: center;justify-content: center;">
                      <p style="color:#7d7d7c" v-html="option.tip"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="'edit' == addOrEdit && wotype == '1'" :style="heightStyle">
              <div style="height: 100%;padding: 20px 20px 0px 20px;">
                <div class="rightOneTop" style="height: auto">
                  <div style="height: 35px;display:flex;align-items: center;justify-content: space-between;margin-bottom:6px">
                    <div id="themeDiv" style="display:flex;align-items: center;">
                      <p style="color:#f39c35;border:1px solid #f39c35;margin-right:25px;width: auto">
                        <Input id="themeInput" :style="inputWidth" style="text-align: center" v-model="orderTheme.popCustomValue"
                               :title="orderTheme.popCustomValue"
                               :placeholder="'输入工单'+orderTheme.customName" :disabled="editTable" @on-blur="editWorkOrder($event,orderTheme,0,0,'','','','telephoneScreen')"/>
                      </p>
                      <p style="margin-right:5px;"><img src="@/assets/image/workOrder/womesicon1.png"/></p>
                      <p style="margin-right:10px;font-size: 14px;">#{{contentList.id}}</p>
                      <p v-if="contentList.dictDescr"
                        style="background-color:#04c343;width:15px;height:15px;line-height:16px;text-align:center;color: white"
                        :style="{'background':contentList.dictDescr.color ? contentList.dictDescr.color:'white'}">{{contentList.dictDescr.shortValue}}</p>
                      <p v-if="contentList.dictDescr" style="color:#04c343;margin-right:10px;margin-left:5px;font-size: 14px;"
                         :style="{'color':contentList.dictDescr.color ? contentList.dictDescr.color:'white'}">
                        {{contentList.orderState}}</p>
                    </div>
                    <div>
                    </div>
                  </div>
                  <div v-if="'edit' == addOrEdit" style="height: 25px;display:flex;align-items: center;justify-content: flex-start;margin-bottom:2px;overflow: hidden">
                    <p style="color:#9ea19f;margin-right:3px;display: flex;align-items: center;">
                      <img src="@/assets/image/workOrder/timeOutRed.png" v-show="showSlaImg == '1'"/>
                      <img src="@/assets/image/workOrder/timeOutGreen.png" v-show="showSlaImg == '2'"/>
                    </p>
                    <p style="color:#9ea19f;margin-right:10px;display: flex;align-items: center;" v-html="contentList.slaTime" :style="showColorForSla">
                    </p>
                    <p v-show="contentList.slaKpi" style="color:#fcfefd;background-color:#a0a0a0;margin-right:10px;padding:0px 5px">SLA指标</p>
                    <p style="color:#9ea19f;margin-right:10px;">{{contentList.slaKpi}}</p>
                  </div>
                  <div style="height: 25px;display:flex;align-items: center;justify-content: flex-start;margin-bottom:2px;overflow: hidden">
                    <p style="color:#9ea19f;margin-right:5px;white-space: nowrap" title="创建时间">{{contentList.createTime}}</p>
                    <p style="color:#9ea19f;margin-left:5px;">|</p>
                    <p style="color:#9ea19f;margin-left:5px;margin-right:5px;white-space: nowrap" title="客户名称">{{contentList.customerName}}</p>
                    <p style="white-space: nowrap"><span>&lt;</span>
                      <span><img src="@/assets/image/workOrder/womesicon3.png"/></span>
                      <span href="javascript:void(0)" style="color:#2d8bef"  @click="messageOrPhone(contentList.customerPhone)" title="手机号码">{{configInfo.phoneIsHide == '1'?contentList.customerPhoneHide:contentList.customerPhone}}</span>
                      <span style="margin-left:5px;"></span>
                      <span>&gt;</span>
                    </p>
                    <p v-show="contentList.serviceGroup" style="color:#9ea19f;margin-left:5px;margin-right:5px;">|</p>
                    <p v-show="contentList.serviceGroup" title="工单服务组" style="color:#9ea19f;white-space: nowrap">&lt;<span>{{contentList.serviceGroup}}</span>&gt;
                    </p>
                    <p v-show="contentList.orderHandler" style="color:#9ea19f;margin-left:5px;margin-right:5px;">|</p>
                    <p v-show="contentList.orderHandler" title="工单处理人" style="color:#9ea19f;white-space: nowrap">&lt;<span>{{contentList.orderHandler}}</span>&gt;
                    </p>
                  </div>
                  <div class="replymo" v-if="showInputAndButton" style="height:130px;width:100%;position:relative;">
                    <div style="height:30px;background-color:#eeeeee;width:100%;padding:5px 0 5px 15px;">
                      <Checkbox v-model="isSecret" style="color:#a1a1a1;margin-right:20px">私密回复</Checkbox>
                      <Poptip placement="top" transfer>
                        <img src="@/assets/image/workOrder/Expressicon.png"/>
                        <div slot="content">
                          <div v-for="(item, index) in emojiList" :key="index">
                            <img :src="emotion.emoji" v-for="(emotion,key) in item" :key="key" :title="emotion.descr"
                                 @click="clickHandler(emotion)"/>
                          </div>
                        </div>
                        <span style="color: #a1a1a1;margin-right:20px;font-size:14px">表情</span>
                      </Poptip>
                      <Upload :action="baseUploadUrl" :on-error="uploadFail" :max-size="15360"
                              :before-upload="handleBeforeUpload" :on-success="(res,file)=>onSuccess(res,file)"
                              :on-exceeded-size="handleMaxSize" :show-upload-list="showUploadList"
                              style="display:inline-block">
                        <img src="@/assets/image/workOrder/Uploadicon.png"/>
                        <span style="color: #a1a1a1;font-size:14px">上传附件</span>
                      </Upload>

                    </div>
                    <p v-if="'edit' == addOrEdit && wotype == '1'" v-model="showAddInput.text" class="edittext" contenteditable="true" ref="editDiv"
                       :placeholder="placeHolderForInput" style="border: 1px solid #dae2fb;margin-top:0px;padding: 4px 7px;height:100px;"
                       @blur="showInput('2')" @input="telInputChange" :class="{'editTextOne':isSecret}"></p>

                    <p v-if="telReplyFlag" style="border: 1px solid #dae2fb;margin-top:10px;position: absolute;width: 100%;z-index:100;" id="replyDiv">
                      <Table :columns="telReplyColumns" :data="telReplyData" :show-header="false" max-height="125" :stripe="false"
                      no-data-text="没有快捷回复内容" @on-row-click="telOnRowClick"></Table>
                    </p>
                    <el-dropdown split-button type="primary" v-show="selectScene" @click="dropClick(selectScene,'telephoneScreen')"
                                 style="width:150px;position:absolute;right:25px;bottom:-45px">
                      {{selectScene}}
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="sceneList && sceneList.length>0" v-for="(itemTwo,indexTwo) in sceneList" :key="indexTwo"
                                          @click.native="dropClick(itemTwo.label,'telephoneScreen')">{{ itemTwo.label }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <div v-if="showInputAndButton" style="width: 68%;height: 50px;overflow: auto">
                    <Upload id="uploadTwo" :action="baseUploadUrl" :default-file-list="uploadList" show-upload-list
                            :on-remove="(file,fileList)=>removeFile(file,fileList)"></Upload>
                  </div>
                  <div v-if="!showInputAndButton" style="width: 100%;height:50px;border-radius: 5px 5px 0 0;border: 1px solid #eff3f6;
            border-bottom: none;color: #8a6d3b;background-color: #fde4e4;display: flex;align-items: center;margin-bottom: 10px;">
                    <span style="color: #8a6d3b;box-sizing: border-box;font-size: 15px;">{{showContent+contentList.orderTime}}</span>
                  </div>
                  <div v-if="showFinish || showReset" style="width: 100%;height: 50px;max-width: 50%;display: flex;align-items: center;margin-bottom: 10px;">
                    <Button v-if="showFinish" type="info" style="margin-left: 10px" @click="auditAndReset('audit','allWorkOrder')">审核工单</Button>
                    <Button v-if="showReset" type="info" style="margin-left: 10px" @click="auditAndReset('reset','allWorkOrder')">重置工单</Button>
                  </div>
                </div>
                <div class="rightOneButtom"
                     :style="rightHeightTwo">
                  <div v-for="(option,indexFlow) in flowList" :key="indexFlow" style="margin-bottom: 20px;">
                    <!-- 客户 -->
                    <div v-if="!option.tip && '0' == option.isAgent"
                         style="display:flex;align-items: flex-start;justify-content: flex-start;width: 95%;">
                      <div style="margin-right:10px">
                        <img src="@/assets/image/workOrder/wocus.png"/>
                      </div>
                      <div style="max-width: 90%;">
                        <div>
                          <p style="display:inline-block;color:#e49149">{{option.agentNumber}}</p>
                          <p style="display:inline-block;color:#e49149">{{option.msgTime}}</p>
                        </div>
                        <div>
                          <div style="float: left;max-width: 90%;" class="editTextThree">
                            <p style="color:#7d7d7c;word-break: break-all;" v-html="replaceMsg(option.content)"></p>
                            <div v-for="(item,indexFile) in option.fileAddr" :key="indexFile">
                              <el-image v-if="item.type && item.type.indexOf('image') != -1"
                                        style="width: 100px; height: 100px" :src="baseImgURL + item.url"
                                        :preview-src-list="(baseImgURL + item.url).split('{yuneasy}')"
                                        fit="contain"></el-image>
                              <div v-else
                                   style="margin-bottom: 10px;width: 150px;height: 68px;padding: 8px 13px;border: #b8b1b1 1px solid;background-color: white">
                                <p :title="item.name"
                                   style="width: 100%;font-size: 12px;height: 16px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: 700;">
                                  {{item.name}}</p>
                                <div style="width: 100%;font-size: 12px;height: 30px;">
                                  <div style="width: 70%;font-size: 12px;height: 100%;float: left">
                                    <img style="width: 30px;height: 30px;" title="附件"
                                         src="@/assets/image/workOrder/download.png">
                                  </div>
                                  <div
                                    style="width: 30%;font-size: 12px;height: 100%;float: right;text-align: right;display: flex;align-items: flex-end;">
                                    <a :href="baseURL+'common/downloadFile.json?type=0&addr='+item.url"
                                       style="color: blue">下载</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 客服 -->
                    <div @mousemove="showImg('1',option,indexFlow,'telephoneScreen')" @mouseleave="showImg('2',option,indexFlow,'telephoneScreen')"
                         v-if="!option.tip && '1' == option.isAgent"
                         style="display:flex;align-items: flex-start;justify-content: flex-start;width: 95%;">
                      <div
                        style=" width:38px;height:38px; border-radius: 50%;position:relative;margin-right:10px;border:1px solid #1d82fe">
                        <img v-if="option.employeeHead"
                             style="border-radius: 50%;  border-radius:50%;width:36px;height:36px;margin-left:10px;position:absolute;left:50%;top:50%;margin-left:-18px;margin-top:-18px "
                             :src="baseImgURL+option.employeeHead"/>
                        <img v-if="!option.employeeHead"
                             style="border-radius: 50%;  border-radius:50%;width:36px;height:36px;margin-left:10px;position:absolute;left:50%;top:50%;margin-left:-18px;margin-top:-18px "
                             src="@/assets/image/customerService.png"/>
                      </div>
                      <div style="max-width: 90%;">
                        <div>
                          <p style="display:inline-block;color:#1d82fe">{{option.agentNumber}}</p>
                          <p style="display:inline-block;color:#1d82fe">{{option.msgTime}}</p>
                        </div>
                        <div style="float: left;max-width: 90%;" class="editTextFour">
                          <p style="color:#7d7d7c;word-break: break-all;" v-html="replaceMsg(option.content)"></p>
                          <div v-for="(item,indexFile) in option.fileAddr" :key="indexFile">
                            <el-image v-if="item.type && item.type.indexOf('image') != -1" style="width: 100px; height: 100px"
                                      :src="baseImgURL + item.url"
                                      :preview-src-list="(baseImgURL + item.url).split('{yuneasy}')" fit="contain"></el-image>
                            <div v-else
                                 style="margin-bottom: 10px;width: 150px;height: 68px;padding: 8px 13px;border: #b8b1b1 1px solid;background-color: white">
                              <p :title="item.name"
                                 style="width: 100%;font-size: 12px;height: 16px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: 700;">
                                {{item.name}}</p>
                              <div style="width: 100%;font-size: 12px;height: 30px;">
                                <div style="width: 70%;font-size: 12px;height: 100%;float: left">
                                  <img style="width: 30px;height: 30px;" title="附件"
                                       src="@/assets/image/workOrder/download.png">
                                </div>
                                <div
                                  style="width: 30%;font-size: 12px;height: 100%;float: right;text-align: right;display: flex;align-items: flex-end;">
                                  <a :href="baseURL+'common/downloadFile.json?type=0&addr='+item.url"
                                     style="color: blue">下载</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style="width: 23px;height: 23px;float: left">
                          <img title="私密信息" src="@/assets/image/workOrder/lock.png" v-if="option.isSecret == '1'"
                               @click="changeSecret(option,indexFlow,'telephoneScreen','telephoneScreen')">
                          <img title="公开信息" src="@/assets/image/workOrder/unlock.png"
                               v-if="option.showImg && option.isSecret == '0'" @click="changeSecret(option,indexFlow)">
                        </div>
                      </div>
                    </div>
                    <!--tip提示-->
                    <div v-if="option.tip" style="display:flex;align-items: center;justify-content: center;">
                      <p style="color:#7d7d7c" v-html="option.tip"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="clear:both"></div>

        </el-tab-pane>
      </el-tabs>
      <Button type="primary" class="submit_btn" @click="confirmSave()" style="position: absolute;right:10px;top:5px;"
              v-if="(wotype != '2' && 'add' == addOrEdit) || 'infor1' == tabsName" :loading="loading">保存
      </Button>
      <serviceRecordDetail @closeServiceRecordDetail="closeServiceRecordDetail"
                           :showServiceRecordDetail="showServiceRecordDetail"
                           :recordId="recordId"></serviceRecordDetail>
      <publicSendMessage @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"
                         :callUpPhone="callUpPhone"></publicSendMessage>
    </div>
    <div style="width: 26%; height: 99%; box-shadow: 3px 3px 10px #9c9c9c; float: right;margin-right:1%"
         v-show="showFlag" v-if="haveVideo == '1' || haveAi == '1'">
      <div v-bind:style="{width:sWidth,height: sHeight}">
        <div v-show="time==1||time==3" class="videointerface" v-bind:style="{width:vWidth,height: vHeight}">
          <div style="width: 100%;background-color: #65a0fe;display: flex;align-items:center;"
               v-bind:style="{height: topHeight}">
            <img style="max-width:100%;max-height:100%;margin-left:5%" src="../../assets/image/agentVedio.png"/>
            <p style="color: white;width: 81%;font-size: 0.23rem">视频座席</p>
          </div>

          <div class="videointerface_deta" id="videoPrefecture" style="width:100%;position:relative;overflow:hidden;"
               v-bind:style="{height: midHeight}">
            <div id="coverbg"
                 style="position:absolute;width: 100%;height:100%;background:#a9a9ab;z-index:3;display:block;"></div>
            <div id="youviewvideo" style="position:absolute;width: 100%;height:100%;background:#a9a9ab;">
              <video id="youview" autoplay="" muted playsinline=""
                     style="height:100%;width:100%;object-fit: fill;"></video>
            </div>
            <div class="oneVideo" id="oneyousvideo" style="position:absolute;width: 100%;background:black;"
                 v-bind:style="{top:viewtop,right:0,height:oneVideoheight}">
              <video id="yousVideo" autoplay="" muted playsinline=""
                     style="height:100%;width:100%;object-fit: fill;"></video>
            </div>
            <div class="oneVideo" id="twomesVideo" style="position:absolute;width:100px;height: 75px;background:black;"
                 v-bind:style="{top:viewtop,right:0}">
              <video id="mesVideo" autoplay="" muted playsinline=""
                     style="width:100%;height:100%;object-fit: fill;"></video>
            </div>
          </div>
        </div>
        <div v-show="time==2||time==3" class="aiinterface" v-bind:style="{width:vWidth,height: aHeight}">
          <div style="width: 100%;background-color: #65a0fe;display: flex;align-items:center;"
               v-bind:style="{height: topHeight}">
            <img style="max-width:100%;max-height:100%;margin-left:5%" src="../../assets/image/AIAgent.png"/>
            <p style="color: white;width: 81%;font-size: 0.23rem">AI助手</p>
          </div>
          <div class="aiintercontain" style="width:100%;overflow-y: auto;" ref="scroller"
               v-bind:style="{height: midHeight}">
            <div style="margin: 10px 15px 0px 15px;" v-for="(item,index) in screenAiContent" :key="index">
              <div v-show="'asrResp'==item.direction" class="ai_cus">
                <div class="ai_cus_info">
                  <div class="ai_cus_infodetail">
                    <img src="../../assets/image/cusHead.png" title="客户头像" class="ai_cus_infoimg"/>
                    <p class="ai_cus_infoname">&nbsp;&nbsp;&nbsp;<span>{{currentAiPhone}}</span></p>
                    <p class="ai_cus_infotime">{{item.time}}</p>
                  </div>
                </div>
                <div class="ai_cus_dialotria"></div>
                <p class="ai_cus_dialofont">{{item.data}}</p>
              </div>
              <div v-show="'asrBegin'==item.direction" class="ai_staff">
                <div class="ai_staff_info">
                  <div class="ai_staff_infodetail">
                    <p class="ai_staff_infotime">{{item.time}}</p>
                    <p class="ai_staff_infoname">{{item.name}}-<span>{{item.agentNo}}</span></p>
                    <div class="ai_staff_infobk">
                      <img :src="employeeHead" class="ai_staff_infoimg"/>
                    </div>
                  </div>
                </div>
                <div class="ai_staff_dialotria"></div>
                <div style="clear:both"></div>
                <p class="ai_staff_dialofont">{{item.data}}</p>
                <div style="clear:both"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-bind:style="{width:xWidth,height: xHeight}" v-if="haveVideo == '1' && haveAi == '1'">
        <div class="tabs_change" :class="{bg:time == 1}" @click="changeTabs(1)">
          <img style="width: 25%;height: 70%;" src="../../assets/image/agentVedio.png" title="视频座席"/>
        </div>
        <div style="width: 2%;height: 100%;background-color: #121f3f;float: left;"></div>
        <div class="tabs_change" :class="{bg:time == 2}" @click="changeTabs(2)">
          <img style="width: 25%;height: 70%;" src="../../assets/image/AIAgent.png" title="AI座席"/>
        </div>
        <div style="width: 2%;height: 100%;background-color: #121f3f;float: left;"></div>
        <div class="tabs_change" :class="{bg:time == 3}" @click="changeTabs(3)">
          <img style="width: 25%;height: 70%;" src="../../assets/image/agentVedio.png"/>
          <img style="width: 25%;height: 70%;" src="../../assets/image/AIAgent.png"/>
        </div>
      </div>
    </div>
    <searchCustomerInfoPop @closeCustomerInfo="closeCustomerInfoOnly"
                           :showCustomerInfo="showCustomerInfo"></searchCustomerInfoPop>
    <el-dialog
      title="追加回复"
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      width="50%">
      <Spin size="large" fix v-if="spinShowForDialog">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>正在加载中...</div>
      </Spin>
      <Input v-model="contentForReply" :placeholder="contentForPlace" type="textarea" :autosize="{minRows: 5,maxRows: 100}"/>
      <Checkbox v-model="isSecretForReply" class="order_class" >私密回复</Checkbox>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveChange('telephoneScreen')">提交回复</el-button>
        <el-button @click="cancelChange">取 消</el-button>
      </span>
    </el-dialog>
    <AuditAndResetPop  @closeHandlerPop="closeHandlerPop" fromWhere="telephoneScreen" :orderFromWhere="orderFromWhere" :workOrderId="workOrderId" :showHandlerPop="showHandlerPop"  :actionForHandler="actionForHandler" ></AuditAndResetPop>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {serviceRecordPub} from '@/components/js/ServiceRecordPub.js'
  import serviceRecordDetail from '@/components/customerMange/ServiceRecordDetailPop.vue'
  import publicSendMessage from '@/components/login/PublicSendMessage.vue'
  import ChatList from "@/components/aiManager/chat/chatList";
  import File from '@/components/customerMange/File.vue'
  import {workOrderPublic} from '@/components/js/WorkOrderPublic.js'
  import searchCustomerInfoPop from '@/components/customerMange/SearchCustomerInfoPop.vue'
  import eventBus from "../../util/eventBus";
  import AuditAndResetPop from '@/components/workOrder/AuditAndResetPop.vue';

  export default {
    name: "TelephoneScreen",
    mixins: [publicFunClass, serviceRecordPub,workOrderPublic],
    props: {
      currentCallData: String,
      reserve: Object,
      changeTabName: Boolean,
    },
    components: {
      serviceRecordDetail,
      publicSendMessage,
      ChatList,
      File,
      searchCustomerInfoPop,
      AuditAndResetPop
    },
    data() {
      return {
        addOrEdit:'',
        sysSupportWorkOrder: JSON.parse(localStorage.getItem("sysSupportWorkOrder")),
        fileData:[],
        tabsName: 'infor1',
        pstnNumber: '',
        showFlag: true,
        cslist: Array,
        selection: '',
        visible: false,
        showForm: false,
        isShow: false,
        currentCallPhone: '',  //当前弹屏页面的号码
        currentCallPhoneHide: '',  //当前弹屏页面的号码
        currentAiPhone: '', //AI助手显示的号码
        roleList: JSON.parse(localStorage.getItem("roleList")),
        questionMark: require('../../assets/image/homeAsk.png'),
        total: 0,
        currentPage: 1,
        speedChangePage: 1,
        pageSize: 20,
        always: true,
        showMessage: false,
        tableClass: true,
        spinShow: true,
        Id: '',
        tabName: '',
        singleCheckedList: [],
        infoTableList: [],
        screenHeight: {height: ''},
        editable: false,
        interval: '',
        customerId: '',
        customerIdList: [],
        telephone: '',
        journalType: '',
        menuId: '',
        serviceId: '',
        formValidate: {"allColumnInfo": []},
        callUuid: '',
        showServiceRecordDetail: false,
        recordId: '',
        screenWidth: {width: '100%'},
        wolistWidth: {width: '20%'},
        woconWidth: {width: '79%'},
        haveAi: "",
        haveVideo: "",
        time: 1,
        meVideo: '',
        youVideo: '',
        screenAiContent: [],
        tool: true,
        employeeHead: './static/img/customerService.2f81c4b.png',
        // heartbeatId: -1,
        vWidth: "100%",
        vHeight: "100%",
        aHeight: "100%",
        sWidth: "100%",
        sHeight: "94%",
        xWidth: "100%",
        xHeight: "6%",
        topHeight: "10%",
        midHeight: "90%",
        oneVideoheight: "100%",
        activeNames: [],
        interactions: [],
        collectionData: '',
        ivrCallLegId: '',
        custUuid: '',
        originalCustUuid: '',
        viewtop: "0",
        // 新加
        showColumnList: null,
        screenColumn: [],
        ServiceRecordList: [],
        serviceFieldList: [],
        activeName: '1',//展开name为1的折叠板
        activelist: '2',
        wotype: '1',
        heightStyle: {'height': '', 'overflow-y': 'auto', 'overflow-x': 'hidden'},
        heightStyleForLeft: {'height': '', 'overflow-y': 'auto', 'overflow-x': 'hidden'},
        isSecret: false,
        sceneList: [
          {
            value: '1',
            label: '回复为解决方案'
          },
          {
            value: '2',
            label: '处理完毕'
          },
          {
            value: '3',
            label: '暂停处理'
          }
        ],
        selscene: '回复',
        showUploadList: false,
        currentIndex: -1,
        historyList: [],
        historywoList: [],
        workOrderId:'',
        flowList: [],
        isClickedWork:false,
        showSlaImg:'',
        editTable:false,
        editHandle:false,
        editCopyId:false,
        orderFromWhere:'',
        handlerList:{},
        rightHeight: {height: ''},
        rightHeightTwo: {height: ''},
        inputWidth: {'width': ''},
        showInputAndButton:false,
        uploadList:[],
        selectScene: '',
        telReplyFlag:false,
        telReplyData:[],
        telReplyColumns: [ { title: 'replyWord', key: 'replyWord', maxWidth:200,ellipsis:true }, { title: 'replyContent', key: 'replyContent',ellipsis:true } ],
        telReplySourceData : '',
        telTextFlag:false, // 中文输入和英文输入的标识
        loading:false,
      }
    },
    methods: {
      //多方关闭AI以及视频
      hideAiAndVideo: function () {
        this.showFlag = false;
        this.clearAgentVideo();
        this.screenWidth.width = '100%';
        this.wolistWidth.with = '20%';
        this.woconWidth.width = '79%';
      },
      refresh: function (callInPhone) {
        if (callInPhone != this.currentCallPhone) {
          return;
        }
        this.showFlag = true;
        if (this.agentInfo.employeeHead) {
          this.employeeHead = this.baseImgURL + this.agentInfo.employeeHead;
        }
        this.haveAi = this.agentInfo.isAiAssistant;
        this.haveVideo = this.agentInfo.isSupportVideo;
        if (this.haveAi == '1' || this.haveVideo == '1') {
          this.screenWidth.width = '72%';
          this.wolistWidth.width = '30%';
          this.woconWidth.width = '69%';
          this.sHeight = "100%";
          this.xHeight = "0%";
          this.viewtop = "25%";
        }
        if (this.haveAi == '1' && this.haveVideo == '1') {
          this.time = 3;
          this.vHeight = "50%";
          this.aHeight = "50%";
          this.sHeight = "94%";
          this.xHeight = "6%";
          this.topHeight = "10%";
          this.midHeight = "90%";
          this.viewtop = "0";
          this.oneVideoheight = "100%";
        } else if (this.haveAi == '1') {
          this.time = 2;
          this.vHeight = "100%";
          this.aHeight = "100%";
          this.topHeight = "5%";
          this.midHeight = "95%";
          this.viewtop = "0";
          this.oneVideoheight = "50%";
        } else if (this.haveVideo == '1') {
          this.time = 1;
          this.vHeight = "100%";
          this.aHeight = "100%";
          this.topHeight = "5%";
          this.midHeight = "95%";
          this.viewtop = "25%";
          this.oneVideoheight = "50%";
        }
      },
      //获取AI内容
      initAiContent: function (param) {
        if(param.customPhone != this.currentCallPhone){
          let custDate = {
            telephone:param.customPhone,
            aiParam:param,
          };
          this.$store.commit('addAIData', custDate);
          return;
        }
        if (this.screenAiContent.length < 1) {
          this.screenAiContent.push(param);
          return;
        }
        let index = param.index;
        let direction = param.direction;
        for (let i = this.screenAiContent.length - 1; i >= 0; i--) {
          if (this.screenAiContent[i].index == index && this.screenAiContent[i].direction == direction) {
            this.$set(this.screenAiContent, i, param);
            // this.screenAiContent[i] = param;
            return;
          }
          if (this.screenAiContent[i].index == (index - 1) && this.screenAiContent[i].direction == direction) {
            break;
          }
        }
        this.screenAiContent.push(param);
      },
      //初始化视频
      initAgentVideo: function () {
        let constraints = {
          audio: true,
          video: {
            faceMode: 'user'
          }
        };
        let that = this;
        let meV = document.getElementById("mesVideo");
        if (!meV) {
          return;
        }
        meV.setAttribute('autoplay', '');
        meV.setAttribute('playsinline', '');
        that.meVideo = meV;
        let youV = document.getElementById("yousVideo");
        youV.setAttribute('autoplay', '');
        youV.setAttribute('playsinline', '');
        let youview = document.getElementById("youview");
        youview.setAttribute('autoplay', '');
        youview.setAttribute('playsinline', '');
        let coverbg = document.getElementById("coverbg");
        coverbg.style.display = "none";
        let youviewvideo = document.getElementById("youviewvideo");
        youviewvideo.style.filter = "blur(30px)";
        navigator.mediaDevices.getUserMedia(constraints).then(function success(stream) {
          meV.srcObject = stream;
          document.body.addEventListener('click', function () {
            meV.play();
          });
          // 等到视频流准备好了
          let interval = setInterval(function () {
            if (!meV.videoWidth) {
              return;
            }
            //stage.appendChild(videoView);
            clearInterval(interval);
          }, 1000 / 50);
        }).catch(function (error) {
          //alert(error.message);
        });
      },
      //开始视频
      doAgentVideo: function (param) {
        let that = this;
        console.log('doAgentVideo - ', param);
        let coverbg = document.getElementById("coverbg");
        coverbg.style.display = "none";
        let youviewvideo = document.getElementById("youviewvideo");
        youviewvideo.style.filter = "blur(30px)";
        let youV = document.getElementById("yousVideo");
        youV.srcObject = param;
        let youview = document.getElementById("youview");
        youview.srcObject = param;

        document.body.addEventListener('click', function () {
          that.meVideo.play();
        });
        // 等到视频流准备好了
        var interval = setInterval(function () {
          if (!that.meVideo) {
            return;
          }
          clearInterval(interval);
        }, 1000 / 50);
      },
      //释放视频资源
      clearAgentVideo: function () {
        if (this.meVideo != null && this.meVideo.srcObject != null) {
          this.meVideo.pause();
          this.meVideo.srcObject.getTracks()[0].stop();
          this.meVideo.srcObject.getTracks()[1].stop();
          this.meVideo.srcObject = null;
        }
        let youviewvideo = document.getElementById("youviewvideo");
        youviewvideo.style.filter = "blur(0px)";

        let coverbg = document.getElementById("coverbg");
        coverbg.style.display = "block";
      },
      //AI视频座席进行点击
      changeTabs: function (index) {
        this.time = index;
        if (this.time == 1 || this.time == 2) {
          this.vHeight = "100%";
          this.aHeight = "100%";
          this.topHeight = "5%";
          this.midHeight = "95%";
          this.viewtop = "25%";
          this.oneVideoheight = "50%";
        } else if (this.time == 3) {
          this.vHeight = "50%";
          this.aHeight = "50%";
          this.topHeight = "10%";
          this.midHeight = "90%";
          this.viewtop = "0";
          this.oneVideoheight = "100%";
        }
      },
      closeServiceRecordDetail: function () {
        this.showServiceRecordDetail = false;
      },
      searchServiceRecordDetail: function (id) {
        this.showServiceRecordDetail = true;
        this.recordId = id;
      },
      sendNoteInfo: function (phone) {
        this.showSendMessage = true;
        this.callUpPhone = phone;
      },
      callPhone: function (phone) {
        if (!phone) {
          this.$Message.info("号码不能为空");
          return false;
        }
        this.$emit("openCallPhone", true, phone, '1');
      },
      //设备信息当前页改变
      changeCurrent(event) {
        this.currentPage = event;
        this.initServiceRecord();
      },
      //设备信息页面显示数量改变
      changeSize(event) {
        this.currentPage = 1;
        this.pageSize = event;
        this.initServiceRecord();
      },
      getSaveParam: function (columnList) {
        let param = {
          journalType: "电话弹屏保存",
          menuId: "null",
          id: '',
          callUuid: this.callUuid
        };
        for (let i = 0; i < columnList.length; i++) {
          let customValue = columnList[i].customValue;
          let customIsMust = columnList[i].customIsMust;
          let customName = columnList[i].customName;
          let customColName = columnList[i].customColName;
          if (customIsMust == '1' && customColName != 'customerId' && customColName != 'employeeId') {
            if (!customValue) {
              this.$Message.info(customName + "不能为空");
              return false;
            }
          }
          if (customColName.indexOf("file") != -1 && customValue) {
            // 如果下载地址是空的，保存时去除这行数据
            let fileJson = JSON.parse(customValue);
            let newFlag = 0;
            for (let n = 0; n < fileJson.length;) {
              newFlag++;
              if (!fileJson[n].downloadAddr) {
                fileJson.splice(n, 1);
              } else if (!fileJson[n].description) {
                this.$Modal.info({
                  title: '提示',
                  content: "" + customName + "的第" + newFlag + "个附件已上传成功，但对应备注为空，请确认后重试"
                });
                this.spinShow = false;
                return false;
              } else {
                n++;
              }
            }
            customValue = JSON.stringify(fileJson);
          }
          //  手机号码字段，且 号码隐藏的，不隐藏的不用替换
          if (customColName.indexOf("telephone") != -1) {
            if (customValue && customValue.indexOf("*") != -1) {
              customValue = columnList[i].customOrigin;//原始的字段信息，比如手机号码，会存放不加密的号码
            } else {
              //不隐藏号码情况下修改了号码
              if (customValue && isNaN(customValue)) {  //包含非数字
                customValue = customValue.replace(/[^0-9]/ig, "");
              }
            }
          }
          let type = columnList[i].type;
          if (!customValue) {
            customValue = "";
          }
          if (type == "datetime" && customValue) {
            if (!(/^[\d\s-]+/.test(customValue))) {
              customValue = this.timeChange(customValue);
            }
          }
          param[columnList[i].customColName] = customValue;
        }
        return param;
      },
      saveCustomerServiceInfo: function (param,flag) {
        //  param.id="";
        if (param.id == "-1") {
          param.id = "";
        }
        param.isHiddenService = this.configInfo.isHiddenService;
        let that = this;
        this.spinShow = true;
        this.$http.post("popUp/insertCustomerInfo.json", param).then(function (res) {
          that.customerResult = res.data.flag;
          if (res.data.flag != "666" && res.data.msg.indexOf("号码已存在") != -1 && (!that.customerId || '-1' == that.customerId)) {
            that.$Message.info("当前客户已被其他座席保存，即将刷新页面");
            that.customerId = "";
            that.initSearch();
            return;
          }
          if (res.data.flag != "666") {
            that.spinShow = false;
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.customerId = res.data.obj;
          that.showColumnList["customerId"] = res.data.obj;
          // 保存成功，多个客户就不能选择了
          that.showColumnList["isChangeCustomer"] = true;
          that.initServiceRecord();
          if('1' == that.sysSupportWorkOrder && flag){
            that.saveWorkOrder();
          }else{
            that.$Message.info("电话弹屏保存成功");
            that.spinShow = false;
            let popSaveFlag = that.configInfo.popSaveFlag;
            if (popSaveFlag == '1') {//启用弹屏自动关闭功能
              that.$emit("closeTelephoneScreen", that.currentCallPhone);
              return false;
            }
          }

        });
      },
      //保存
      save: function (flag) {
        //  this.showColumnList["columnList"]=that.getListValue(that.customerList[0],this.showColumnList.columnList);
        //    this.showColumnList["isShowList"]=that.getListValue(that.customerList[0],this.showColumnList.isShowList);
        // 将客户列表字段和服务列表字段拼接成一个json字符串传给后端
        let columnList = this.showColumnList.columnList.concat(this.showColumnList.isShowList).concat(this.showColumnList.serviceList);
        let param = this.getSaveParam(columnList);
        if (!param) {
          return false;
        }
        param.id = this.showColumnList["customerId"];
        this.saveCustomerServiceInfo(param,flag);
      },
      handleOpenForCust: function () {
        if (this.visible) {
          this.visible = false;
          this.isShow = false;
        } else {
          this.visible = true;
          this.isShow = true;
        }
      },
      //初始化查询历史服务记录
      initServiceRecord: function () {
        let that = this;
        let param = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          journalType: "弹屏信息",
          menuId: "null",
          type: '2',
          customerId: this.showColumnList.customerId,
        };
        this.$http.post("popUp/getTabInfo.json", param).then(function (res) {
          let result = res.data.flag;
          that.showForm = true;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          //              初始化服务记录字段，不然多次切换会有多个相同的字段
          that.serviceFieldList = [];
          let fieldList = res.data.obj.fields;
          that.ServiceRecordList = res.data.obj.list.content;
          that.total = res.data.obj.list.totalSize;
          //  对服务记录号码做加密
          if (that.configInfo.phoneIsHide == 1) {
            for (let i = 0; i < that.ServiceRecordList.length; i++) {
              if (that.ServiceRecordList[i].telephoneOne) {
                that.ServiceRecordList[i].telephoneOne = that.ServiceRecordList[i].telephoneOneHide;
              }
              if (that.ServiceRecordList[i].telephoneTwo) {
                that.ServiceRecordList[i].telephoneTwo = that.ServiceRecordList[i].telephoneTwoHide;
              }
              if (that.ServiceRecordList[i].telephoneThree) {
                that.ServiceRecordList[i].telephoneThree = that.ServiceRecordList[i].telephoneThreeHide;
              }
              if (that.ServiceRecordList[i].telephoneFour) {
                that.ServiceRecordList[i].telephoneFour = that.ServiceRecordList[i].telephoneFourHide;
              }
              if (that.ServiceRecordList[i].telephoneFive) {
                that.ServiceRecordList[i].telephoneFive = that.ServiceRecordList[i].telephoneFiveHide;
              }
            }
          }
          let allColumnInfo = [];
          let countFix = 0;
          let phoneIsHide= that.configInfo.phoneIsHide;
          let phoneOwnership= that.configInfo.phoneOwnership;
          for (let i = 0; i < fieldList.length; i++) {
            let customColName = fieldList[i].customColName;
            let customName = fieldList[i].customName;
            let customIsShow = fieldList[i].customIsShow;
            let customType = fieldList[i].customType;
            let customIsMust = fieldList[i].customIsMust;
            let customIsSystem = fieldList[i].customIsSystem;
            let customIsAlter = fieldList[i].customIsAlter;
            if (customColName == "customerId") {
              customColName = "customerName";
            }
            if (customColName == "employeeId") {
              customColName = "employeeName";
            }
            
            let tableHead = {
              title: customName,
              key: customColName,
              height: 40
            };
            if (customIsShow == '1') {
              countFix++;
              if(customColName.indexOf("telephone")!=-1 || customColName.indexOf("Telephone")!=-1){
                if(phoneIsHide=='1'){
                  tableHead.key=customColName+"Hide";
                }
                that.serviceFieldList.push(tableHead);
                if(phoneOwnership=='1'){
                  let tableHead1={
                    title: customName+"归属地",
                    key: customColName+"Address",
                    height:40
                  };
                  that.serviceFieldList.push(tableHead1);
                }
              }else {
                that.serviceFieldList.push(tableHead);
              }
            }
            let columnParam = {
              type: customType,
              customColName: customColName,
              customValue: customType == 'cascade' ? [] : '',
              popCustomValue: customType == 'cascade' ? [] : '',
              checkName: "customValue",
              customIsMust: customIsMust,
              customName: customName,
              customIsAlter: customIsAlter,
              customIsSystem: customIsSystem,
              customOrigin: '',//原始的字段信息，比如手机号码，会存放不加密的号码
              list: fieldList[i].list,
            };
            allColumnInfo.push(columnParam);
          }
          that.formValidate.allColumnInfo = allColumnInfo;
          if (countFix > 10) {
            for (let k = 0; k < that.fieldList.length; k++) {
              that.fieldList[k]["width"] = "150";
              if (k < 3) {
                that.fieldList[k]["fixed"] = true;
              }
            }
          }
          //  that.handleScroll();
        });
      },
      //初始化查询服务信息
      initServiceInfo: function (param) {
        let that = this;
        param["type"] = "1";
        this.$http.post("popUp/getTabInfo.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          let fieldList = res.data.obj.fields;
          let contentList = res.data.obj.list.content;

          let columnList = [];
          let serviceRule = {};
          for (let i = 0; i < fieldList.length; i++) {
            let customColName = fieldList[i].customColName;
            if (customColName.indexOf('customerId') != -1 || customColName.indexOf('telephone') != -1) {
              continue;
            }
            let customName = fieldList[i].customName;
            let customType = fieldList[i].customType;
            let customIsMust = fieldList[i].customIsMust;
            let customIsAlter = fieldList[i].customIsAlter;
            let customIsSystem = fieldList[i].customIsSystem;
            let listData = fieldList[i].list;
            if (!listData) {
              listData = [];
            }
            let customValue = fieldList[i].customType == 'cascade' ? [] : '';
            
            let columnParam = {
              type: customType,
              customColName: customColName,
              customValue: customValue,
              customIsMust: customIsMust,
              customName: customName,
              customIsAlter: customIsAlter,
              customIsSystem: customIsSystem,
              customOrigin: '',
              list: listData,
            };
            columnList.push(columnParam);
            let list = [{required: true}];
            if (customIsMust == '1') {
              serviceRule[customColName] = list;
            }
          }
          that.showColumnList["serviceList"] = that.getListValue(contentList[0], columnList);
          that.showColumnList["serviceRule"] = serviceRule;
          that.showColumnList["agentUUid"] = that.callUuid;
          that.showColumnList["pstnNumber"] = that.pstnNumber;
          that.showColumnList["screenAiContent"] = that.screenAiContent;
          that.screenColumn = that.showColumnList;

          // 担心有个指针问题，会把已有的数据赋值成新的数据
          that.showColumnList.showForm = true;
          that.$store.commit('addCustomerData', that.showColumnList);
          that.showForm = true;
        });
      },
      //初始化查询客户
      initCustomer: function (paramInfo) {
        let that = this;
        this.$http.post("popUp/getCustomerInfo.json", paramInfo).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          let fieldList = res.data.obj.fields;
          that.customerList = res.data.obj.list.content;  //客户列表数据
          if (that.customerList.length == 0) {  //如果没有搜索到客户，表示是新客户，取号码、隐藏号码和id=-1值
            that.customerList = res.data.obj.content;
          }

          // 多个客户时，默认选中第一个
          that.customerId = that.customerList[0].id;

          //  字段处理
          let columnList = [];
          let isShowList = [];
          let customerRule = {};
          for (let i = 0; i < fieldList.length; i++) {
            let customColName = fieldList[i].customColName;
            let customName = fieldList[i].customName;
            let customType = fieldList[i].customType;
            let customIsMust = fieldList[i].customIsMust;
            let customIsShow = fieldList[i].customIsShow;
            let customIsAlter = fieldList[i].customIsAlter;
            let customIsSystem = fieldList[i].customIsSystem;
            let listData = fieldList[i].list;
            if (!listData) {
              listData = [];
            }
            let isModifyManager = that.configInfo.isModifyManager;
            if (that.customerList.length != 0 && customColName == 'customerManager') {
              customIsAlter = isModifyManager;
            }
            let columnParam = {
              type: customType,
              customColName: customColName,
              customValue: fieldList[i].customType == 'cascade' ? [] : '',
              customIsMust: customIsMust,
              customName: customName,
              customIsAlter: customIsAlter,
              customIsSystem: customIsSystem,
              customOrigin: '',  //原始的字段信息，比如手机号码，会存放不加密的号码
              list: listData,
            };
            if (customIsShow == '0') {
              isShowList.push(columnParam);
            } else {
              columnList.push(columnParam);
            }
            let list = [{required: true}];
            if (customIsMust == '1') {
              customerRule[customColName] = list;
            }
          }
          that.showColumnList["customerId"] = that.customerList[0].id;
          that.showColumnList["columnList"] = that.getListValue(that.customerList[0], columnList);
          that.showColumnList["isShowList"] = that.getListValue(that.customerList[0], isShowList);
          that.showColumnList["customerRule"] = customerRule;
          that.showColumnList["customerList"] = that.customerList;
          that.spinShow = false;

          if ('0' == that.configInfo.isHiddenService) {
            that.initServiceInfo(paramInfo);
          }
          if ('1' == that.sysSupportWorkOrder) {
            that.initWorkOrder('telephoneScreen');
          }
          //延迟1秒执行
          let custName = paramInfo.telephone
          if (that.customerList.length > 0) {
            if (that.customerList[0].customerName) {
              custName = that.customerList[0].customerName
            }
          }
          setTimeout(() => {
            that.initInteractions(that.originalCustUuid, custName, that.ivrCallLegId)
          }, 5000)
        });
      },
      //  弹屏有多个客户时，切换客户事件
      changeCustomerFun: function (customerId) {
        if (customerId && this.customerList) {
          this.showColumnList.columnList = this.getListValue(this.customerList.find(item => item.id === customerId), this.showColumnList.columnList);
          this.customerId = customerId;  //切换时每次切换id
          this.showColumnList.customerId = customerId;
          // 重新获取服务记录,这里每次切换都会获取，即使不在服务记录页面。后期再优化
          if ('0' == this.configInfo.isHiddenService) {
            this.initServiceRecord();
          }
        }
      },
      //初始化客户交互信息
      initInteractions(callUuid, custName, ivrCallLegId) {
        let param = {
          callUuid: callUuid,
          customName: custName,
          ivrCallLegId: ivrCallLegId
        }
        let that = this
        this.$http.post('/popUp/interactions', param).then(res => {
          let response = res.data
          if (response.flag !== '666') {
            console.log('load customer interactions error:', response.msg)
          }
          that.interactions = response.obj
        })
      },
      bindEvent(play) {
        this.$emit('clickTalk', play)
      },
      loadHistoryHandler() {
        const {historyConfig: {callback = null} = {}} = this.chatListConfig
        callback && callback()
      },
      initSearch: function () {

        this.spinShow = true;
        let paramInfo = {
          journalType: "弹屏信息",
          menuId: "null",
          telephone: this.currentCallPhone,
          id: this.customerId,
          callUuid: this.callUuid
        };
        this.showColumnList = {
          "telephone": this.currentCallPhone,  //号码
          "customerId": this.customerId, //客户id
          "showForm": true, //是否显示布局
          "columnList": [], //客户显示列
          "isShowList": [],  //显示字段
          "serviceList": [], //服务记录字段
          "serviceRule": {}, //服务记录是否必填、唯一规则
          "customerRule": {}, //客户是否必填、唯一规则
          "customerList": {}, //客户列表
          "isChangeCustomer": false,  //多个客户保存后不能修改，根据这个参数判断
        }
        this.initCustomer(paramInfo);
      },
      getListValue: function (contentList, list) {
        for (let i = 0; i < list.length; i++) {
          let customColName = list[i].customColName;
          let type = list[i].type;
          for (let key in contentList) {
            let value = contentList[key];
            if (customColName == key) {
              list[i].customValue = value;

              if (type == 'checkbox' || type == 'radio' || type == 'select' || type == 'cascade') {
                list[i].customValue = contentList[key + "Id"];
              }
            }
          }
          // 对系统的禁用的字段进行处理
          if(list[i].customIsSystem == '1' && (type=='checkbox' || type=='radio' || type=='select')){
                
                if(list[i] && list[i].list){
                  list[i].list = list[i].list.filter(item => item.isClose == '1' || !item.isClose);
                }
          }

          if (customColName.indexOf('telephone') != -1) {
            list[i].customOrigin = list[i].customValue;//原始的字段信息，比如手机号码，会存放不加密的号码
            if (this.configInfo.phoneIsHide == 1) {  //隐藏号码
              let phoneHide = contentList[customColName + 'Hide'];
              if (!phoneHide) {
                phoneHide = "";
              }
              if (this.configInfo.phoneOwnership == 1) {
                let address = contentList[customColName + "Address"];
                if (!address) {
                  address = "";
                } else {
                  address = "(" + address + ")";
                }
                list[i].customValue = phoneHide + address;
              } else {
                list[i].customValue = phoneHide;
              }
              this.currentAiPhone = this.currentCallPhoneHide;
            } else {
              let phone = contentList[customColName];
              if (!phone) {
                phone = "";
              }
              if (this.configInfo.phoneOwnership == 1) {  //号码归属地
                let address = contentList[customColName + "Address"];
                if (!address) {
                  address = "";
                } else {
                  address = "(" + address + ")";
                }

                list[i].customValue = phone + address;
              } else {
                list[i].customValue = phone;
              }
              this.currentAiPhone = this.currentCallPhone;
            }
            if (list[i].customOrigin == this.currentCallPhone) { // 弹屏不允许修改来电号码
              list[i].customIsAlter = '0';
            } else {
              list[i].customIsAlter = '1';
            }
          }
          if (customColName == "employeeName") {
            list[i].customValue = this.agentInfo.employeeName;
          }
          if (customColName == "customerManager" && !list[i].customValue) {
            list[i].customValue = this.agentInfo.employeeId;
          }
          //新客户默认客户经理
          if (customColName == "customerManager") {
            let info = list[i].list.find(item => item.id === list[i].customValue);
            if (!info) {
              let param = {
                "dictCode": list[i].list[0].dictCode,
                "dictValue": contentList["customerManager"],
                "id": list[i].customValue
              }
              list[i].list.push(param);
            }
          }
          // 如果是服务渠道，在这里默认为电话渠道
          if(customColName == "serviceChannel") {
            if(list[i].list.find(item => item.id == '-6')){  //电话渠道不被禁用，才默认给电话渠道
              list[i].customValue = "-6";
            }
          }
        }
        return list
      },
      scrollToBottom: function () {
        this.$nextTick(() => {
          let that = this;
          const container = that.$refs.scroller;
          if (container == "" || container == null || container == undefined) {
          } else {
            container.scrollTop = container.scrollHeight;
          }
        })
      },
      // 弹屏服务信息切换tab回调方法
      clickChangeTabs: function (tabName) {
        if ("name2" === tabName) {
          this.initServiceRecord();
        } else if ("name3" === tabName) {
          this.initInteractions(this.callUuid, this.showColumnList.columnList.find(item => item.customColName = "customerName").customValue, this.ivrCallLegId);
        }
      },
      //TODO 后期进行摘出进行共用
      showInput: function (action) {
        let newHtml = "";
        let flag = false;
        if(this.$refs.editDiv){
          newHtml = this.$refs.editDiv.innerHTML;
        }else{
          newHtml = this.$refs.editDivHistory[0].innerHTML;
          flag = true;
        }
        if (!newHtml) {
          if(newHtml == this.showAddInput.text){
            return;
          }
        }
        if(!flag){
          this.showAddInput.text = newHtml;
        }
      },
      liClick(item, index) {
        this.currentIndex = index;
        this.selscene = "回复";
        if (item.orderState == '已关闭' || item.orderState == '已删除' || item.orderState == '已完成') {
          this.selscene = "";
        }
        let param = {
          journalType: "",
          menuId: "",
          id: item.id,
          historySearchFlag:'1'
        };
        let that = this;
        that.spinShow = true;
        this.$http.post("workOrder/toEdit.json", param).then(function (res) {
          that.spinShow = false;
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          let contentList = [];
          let flowList = [];
          if(res.data.obj.list && res.data.obj.list.length>0) {
            contentList = res.data.obj.list[0];
            if (contentList.dictDescr) {
              contentList.dictDescr = JSON.parse(contentList.dictDescr);
            }
            // //sla时间格式化
            let newSlaTime = that.getSlaTime(contentList.isSlaTime,contentList.slaTime,contentList.dictDescr ? contentList.dictDescr.color ? contentList.dictDescr.color : '' : '');
            contentList.slaTime = newSlaTime.realValue;
            contentList.showColorForSla = newSlaTime.showColorForSla;
            contentList.showSlaImg = newSlaTime.showSlaImg;
          }
          if(res.data.obj.flowList && res.data.obj.flowList.length>0) {
            //这里将客户与座席谈话的list里面的文件地址转成JSON
            flowList = res.data.obj.flowList;
            for (let i = 0; i < flowList.length; i++) {
              if (flowList[i].fileAddr) {
                flowList[i].fileAddr = JSON.parse(flowList[i].fileAddr);
              }
            }
          }
          that.historywoList = [{staffId: item.id, staffName: item.orderTheme, staffState: item.orderState,contentList:contentList,flowList:flowList}];
        });
      },
      saveWorkOrder:function(){
        let uploadList = "";
        if (this.uploadList && this.uploadList.length > 0) {
          uploadList = JSON.stringify(this.uploadList);
        }

        let that = this;
        this.spinShow = true;
        let param = {
          journalType: "电话弹屏=>添加工单",
          menuId: '',
          customerId: this.customerId,
          fileAddr: uploadList,
          isSecret: this.isSecret ? "1" : "0"
        };
        let newHtml = this.$refs.editDiv.innerHTML;
        let newStr = '';
        if(newHtml){
          let str = newHtml.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
            .replace(/<\/?.+?\/?>/g, ''); //替换html标签
          newStr = str.replace(/[ ]|[\r\n]/g, "").replace(/&nbsp;/g,"");
        }
        let phoneIsHide = that.configInfo.phoneIsHide;
        for (let j = 0; j < this.fileData.length; j++) {
          let allColumnInfo = this.fileData[j].allColumnInfo;
          for (let i = 0; i < allColumnInfo.length; i++) {
            let popCustomValue = allColumnInfo[i].popCustomValue;
            let customColName = allColumnInfo[i].customColName;
            let type = allColumnInfo[i].type;
            if (!popCustomValue || popCustomValue.length == 0) {
              popCustomValue = "";
            }
            if ((type == "cascade" || type == "checkbox") && popCustomValue.length > 0) {
              popCustomValue = popCustomValue.toString();
            }
            if (type == "datetime" && popCustomValue) {
              popCustomValue = this.timeChange(popCustomValue);
            }
            if (type == "file" && popCustomValue) {
              // 如果下载地址是空的，保存时去除这行数据
              let fileJson = JSON.parse(popCustomValue);
              let newFlag = 0;
              for (let n = 0; n < fileJson.length;) {
                newFlag++;
                if (!fileJson[n].downloadAddr) {
                  fileJson.splice(n, 1);
                } else if (!fileJson[n].description) {
                  let customName = allColumnInfo[i].customName;
                  that.$Modal.info({
                    title: '提示',
                    content: "" + customName + "的第" + newFlag + "个附件已上传成功，但对应备注为空，请确认后重试"
                  });
                  this.spinShow = false;
                  return false;
                } else {
                  n++;
                }
              }
              popCustomValue = JSON.stringify(fileJson);
            }
            if (customColName.indexOf("customerPhone") != -1) {
                popCustomValue = this.currentCallPhone;
            }
            if (customColName.indexOf("orderDescribe") != -1) {
              popCustomValue = newStr;
            }
            if (customColName.indexOf("orderTheme") != -1) {
              popCustomValue = this.orderTheme.popCustomValue;
            }

            param[allColumnInfo[i].customColName] = popCustomValue;
          }
        }
        let columnList = this.showColumnList.columnList ? this.showColumnList.columnList : [];
        let newItem = columnList.find(item => item.customColName == 'customerName');
        param.customerName = newItem.customValue;
        let url = "workOrder/doSave.json";
        this.$http.post(url, param).then(function (res) {
          that.spinShow = false;
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          let orderId = res.data.obj;
          if (orderId) {
            that.workOrderId = orderId;
          }
          that.showAddInput.text = '';
          that.$Message.info("电话弹屏保存成功");
          let popSaveFlag = that.configInfo.popSaveFlag;
          if (popSaveFlag == '1') {//启用弹屏自动关闭功能
            that.$emit("closeTelephoneScreen", that.currentCallPhone);
            return false;
          }
          that.showColumnList["workOrderId"] = orderId;
          // 担心有个指针问题，会把已有的数据赋值成新的数据
          that.$store.commit('addCustomerData', that.showColumnList);
          that.initWorkOrder('telephoneScreen');
        });
      },
      confirmSave:function(){
        if(this.isClickedWork && 'add' == this.addOrEdit){
          if('infor2' == this.tabsName){
            this.save(true);
            return;
          }
          this.$confirm('是否保存工单？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning'
          }).then(() => {
            this.save(true);
          }).catch(() => {
            this.save(false);
          });
        }else{
          this.save(false);
        }
      },
      refreshCustomerName:function(){
        let columnList = this.showColumnList.columnList ? this.showColumnList.columnList : [];
        let newItem = columnList.find(item => item.customColName == 'customerName');
        let workOrderList = this.showColumnList.workOrderList ? this.showColumnList.workOrderList : [];
        for (let i = 0;i < workOrderList.length; i++){
          let fieldList = workOrderList[i].fieldList ? workOrderList[i].fieldList : [];
          for (let j = 0; j < fieldList.length; j++) {
            if('customerName' == fieldList[j].customColName){
              this.showColumnList.workOrderList[i].fieldList[j].popCustomValue = newItem.customValue;
              this.fileData[i].allColumnInfo[j].popCustomValue = newItem.customValue;
              break;
            }
          }
        }
      },
      changeTabsName:function(){
        if('infor2' == this.tabsName){
          this.isClickedWork = true;
          this.refreshCustomerName();
        }
        this.showColumnList["tabsName"] = this.tabsName;
        this.$store.commit('addCustomerData', this.showColumnList);
      },
      //从弹屏跳转至工单详情
      openDetail:function(id,tittle){
        let code = "b_w_1-"+id;
        tittle = tittle.replace(/<[^>]+>/g, "");
        if (tittle && tittle.length > 5) {
          tittle = tittle.substring(0, 5) + "…";
        }
        this.$emit("showStandardPage",code+","+tittle+"",this.fileData);
        let param = {
          pageUuId:code,
        };
        let newGroupList = JSON.parse(JSON.stringify(this.fileData));
        newGroupList.push(param)
        this.$store.commit('addWorkOrderReserve',newGroupList);
      },
      closeCustomerInfoOnly:function(flag, selection){
        this.closeCustomerInfo(flag, selection, 'telephoneScreen');
      },
      bindEvents:function () {
        let that = this
        eventBus.$on('findWorkOrderIsOpen', function (workOrderId) {
          if('1' == that.wotype && workOrderId == that.workOrderId){
            that.initWorkOrder('telephoneScreen');
          }
          if(that.wotype == '2'){
            if(that.historyList.find(item => item.id === workOrderId)){
              that.getHistoryWork();
            }
          }
        });
      },
      // 输入时变化回调
    telInputChange:function(e){
      let content = "";
      if(this.$refs.editDiv){
        content = this.$refs.editDiv.innerHTML;
      }else{
        content = this.$refs.editDivHistory[0].innerHTML;
      }
      if(e.data){
        if(e.data === '#'){
          this.telReplySourceData = JSON.parse(localStorage.getItem("ChatReplyWorkAndContent"))
          if(!this.telReplyFlag){
            this.telReplyFlag = true;
            this.telReplyData = this.telReplySourceData;
          }
        }
          let content = "";
          if(this.$refs.editDiv){
            content = this.$refs.editDiv.innerHTML;
          }else{
            content = this.$refs.editDivHistory[0].innerHTML;
          }
          let searchStr = content.substring(content.lastIndexOf('#'),content.length);
          if(this.telReplySourceData){
            this.telReplyData = this.telReplySourceData.filter(item => item.replyWord.indexOf(searchStr.replace('#','')) > -1 );
          }
          // this.moveLast();
      }else{
        if(content.lastIndexOf('#')>-1){
          let searchStr = content.substring(content.lastIndexOf('#'),content.length);
          if(this.telReplySourceData){
            this.telReplyData = this.telReplySourceData.filter(item => item.replyWord.indexOf(searchStr.replace('#','')) > -1 );
          }
        }else{
          this.telReplyFlag = false;
        }
        // this.moveLast();
      }
      if(this.telReplyData.length > 0 && content.lastIndexOf('#')>-1){
        this.telReplyFlag = true;
      }
      if(this.telReplyData.length == 0){ //没数据隐藏
        this.telReplyFlag = false;
      }
      // 这里判断主要是因为 中文状态下输入这些字符，会有两个事件过来，导致前后两个相同的字符
      if((e.inputType == 'insertCompositionText')){
        let char = '~,！,@,#,￥,%,……,&,*,（,）,——,+,{,},|,《,》,？,·,-,=,【,】,、,；,‘,：,”,，,。,、,·';
        if(char.indexOf(e.data) > -1){
          this.telTextFlag = true;
          this.showInput('2');
          let that = this;
          setTimeout(function(){
            that.telTextFlag = false;
          },10);
        }
      }else{
        if(!this.telTextFlag){
          this.telTextFlag = false;
          this.showInput('2');
        }
      }
    },
      // 快捷回复点击
      telOnRowClick:function(data,index){
        let content = "";
        if(this.$refs.editDiv){
          content = this.$refs.editDiv.innerHTML;
          this.$refs.editDiv.innerHTML = content.substring(0,content.lastIndexOf('#'))+data.replyContent;
        }else{
          content = this.$refs.editDivHistory[0].innerHTML;
          this.$refs.editDivHistory[0].innerHTML = content.substring(0,content.lastIndexOf('#'))+data.replyContent;
        }
        this.showInput('2');
        this.telReplyFlag = false;
      },
      // 上传文件过程中不能保存，调用的接口
          fileUploadCallback(flag){
            if(flag || flag == 'true'){
              this.loading = true;
            }else{
              this.loading = false;
            }
          }
    },
    destroyed() {
      eventBus.$off('findWorkOrderIsOpen');
    },
    created() {
      this.screenHeight.height = this.mountHeight(91);
      this.heightStyle.height = this.mountHeight(150);
      this.heightStyleForLeft.height = this.mountHeight(150);
    },
    computed: {
      chatListConfig() {
        const {width = '100%', height = '600px', scrollToButton, scrollType, config: {historyConfig = {}} = {}} = this
        return {width, height, scrollToButton, scrollType, historyConfig}
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.bindEvents();
      });
      this.scrollToBottom();
      window.refresh = this.refresh;
      window.hideAiAndVideo = this.hideAiAndVideo;
      window.initAiContent = this.initAiContent;
    },
    watch: {
      wotype:function(){
        this.showColumnList["wotype"] = this.wotype;
        this.$store.commit('addCustomerData', this.showColumnList);
        if(this.wotype == '2'){
          this.heightStyleForLeft.height = this.mountHeight(190);
          this.getHistoryWork();
          return;
        }
        if(this.wotype == '1' && 'edit' == this.addOrEdit){
          this.initWorkOrder('telephoneScreen');
        }
        this.heightStyleForLeft.height = this.mountHeight(150);
        this.$nextTick(() => {
          if(this.showAddInput.text && this.$refs.editDiv){
            this.$refs.editDiv.innerHTML = this.showAddInput.text;
          }else{
            if(this.$refs.editDiv && '1' == this.wotype) {
              this.$refs.editDiv.innerHTML = '';
            }
          }
        })
      },
      hisTotal: function () {
        if (this.hisTotal <= this.hisPageSize) {
          this.hisCurrentPage = 1;
        }
      },
      currentPage: function () {
        this.speedChangePage = this.currentPage;
      },
      total: function () {
        if (this.total <= this.pageSize) {
          this.speedChangePage = 1;
          this.currentPage = 1;
        }
      },
      currentCallData: function (obj) {
        // 如果为null或为空，可能是其他页面或切换到弹屏页面
        let reserve = this.$store.getters.getReserve(obj.split(",")[0]);
        document.onkeydown = undefined;
        document.onkeydown = function () {
          let key = window.event.keyCode;
          if (key === 13) {
            return false;
          }
        };
        this.screenAiContent = [];
        this.visible = false;
        this.showForm = false;
        this.isShow = false;
        this.tabName = "name3";
        if('0' == this.configInfo.isHiddenService){
          this.tabName = "name1";
        }
        this.customerId = "";
        this.fieldList = [];
        this.customerIdList = [];
        let flag = false;
        //判断是否为新电话接入。需刷新服务、工单
        if (this.callUuid && reserve.callUuid != this.callUuid && this.telephone == reserve.callPhone) {
          flag = true;
        }
        this.callUuid = reserve.callUuid;
        this.telephone = reserve.callPhone;
        this.currentCallPhone = reserve.callPhone;
        this.currentCallPhoneHide = reserve.callPhoneHide;
        this.contentList = [];
        this.workOrderId = '-1';
        this.showAddInput = {text:''};
        // 获取相关数据，获取不到inintSearch
        this.showColumnList = this.$store.getters.getCustomerData(obj.split(",")[0]);

        if (!this.showColumnList) {
          this.wotype = '1';
          this.initSearch();
        } else {
          this.screenColumn = this.showColumnList;
          this.customerList = this.showColumnList.customerList;
          this.customerId = this.showColumnList.customerId;
          this.pstnNumber = this.showColumnList.pstnNumber;
          this.screenAiContent = this.showColumnList.screenAiContent;
          this.addOrEdit = 'add';
          if('1' == this.sysSupportWorkOrder){
            this.tabsName = this.showColumnList.tabsName;
            this.wotype = this.showColumnList.wotype;
            if('2' == this.wotype){
              this.getHistoryWork();
            }
            if(!flag){
              this.workOrderId = this.showColumnList.workOrderId;
              this.uploadList = this.showColumnList.uploadList;
              this.orderDescribe = this.showColumnList.orderDescribe;
              this.orderTheme = this.showColumnList.orderTheme
              this.historyList = this.showColumnList.historyList;
              this.historywoList = this.showColumnList.historywoList;
              this.showAddInput = this.showColumnList.showAddInput;
              if(this.workOrderId && '-1' != this.workOrderId){
                this.initWorkOrder('telephoneScreen');
              }
            }else {
              this.workOrderId = '-1';
              this.uploadList = [];
              this.orderDescribe = {};
              this.orderTheme = {};
              this.historyList = [];
              this.historywoList = [];
              this.showAddInput = {text:''};
              this.initWorkOrder('telephoneScreen');
            }
          }
          //工单赋予
          this.fileData = this.showColumnList.workOrderList;
          console.log(this.fileData);

          if (flag && '0' == this.configInfo.isHiddenService) {
            let paramInfo = {
              journalType: "弹屏信息",
              menuId: "null",
              telephone: this.currentCallPhone,
              id: this.customerId,
              callUuid: this.callUuid
            };
            this.initServiceInfo(paramInfo);
          }
        }
        this.refresh(this.currentCallPhone);
        this.$nextTick(() => {
          if(this.showAddInput.text && this.$refs.editDiv){
            this.$refs.editDiv.innerHTML = this.showAddInput.text;
          }else{
            if(this.$refs.editDiv && '1' == this.wotype) {
              this.$refs.editDiv.innerHTML = '';
            }
          }
        })
        this.$forceUpdate();
      },
      // 深度监听，当val参数不一样时，每次进页面都会进入此监听方法
      reserve: {
        deep: true,
        handler(val) {
          if (val) {
            if ('1' == this.configInfo.screenShow) {
              this.tabsName = 'infor2';
              this.changeTabsName();
            } else {
              this.tabsName = 'infor1';
            }
            this.pstnNumber = val.callcenterNum
            this.collectionData = val.reserve
            this.ivrCallLegId = val.ivrCallLegId
            this.custUuid = val.custUuid
            this.originalCustUuid = val.originalCustUuid
          }
        },
        immediate: true
      }
    },
    updated: function () {
      this.scrollToBottom();
      this.$nextTick(() => {
        this.clientScreenHeight('screen');
      })
    },
  }
</script>

<style lang="less" scoped>
  // 附件、文本域样式，这里没和客户管理、服务记录使用一样，是因为他们的样式在布局上有一点不一样
  .teleFormStyle {
    width: 96% !important;
  }

  .teleFormStyle /deep/ .ivu-form-item-label {
    width: 15% !important;
  }

  .teleFormStyle /deep/ .ivu-form-item-content {
    width: 85% !important;
  }

  .teleFormStyle /deep/ .ivu-input-type-textarea {
    height: auto !important;
  }
  .wotab /deep/ .el-tabs--border-card > .el-tabs__content {
    padding: 0px;
  }

  .wotab /deep/ .el-tabs__nav {
    width: 100%;
  }

  .wotab /deep/ .el-tabs__item {
    width: 50%;
    text-align: center;
  }

  .wotab /deep/ .el-tabs--border-card {
    border: 1px solid transparent;
    box-shadow: 0 2px 4px 0 transparent;
  }

  .itemBg {
    background: transparent;
  }

  .checkedItemBg {
    background: #cce6fd;
  }

  .edittext:empty::before {
    color: lightgrey;
    content: attr(placeholder);
  }

  .replymo /deep/ .ivu-select-single .ivu-select-selection {
    background: #2d8cf0;
    color: white;
  }

  .replymo /deep/ .ivu-select-arrow {
    color: white;
  }

  .historyactive {
    background: #b0d1f2;
  }
  #themeDiv /deep/ .ivu-input {
    border: 0;
    box-shadow: none;
    color: rgb(243, 156, 53);
  }

  #uploadTwo /deep/ .ivu-upload-select {
    display: none;
  }

  .editTextOne {
    background-color: ivory;
  }

  .editTextThree {
    padding: 6px;
    border: rgb(246, 186, 119) 1px solid;
    border-radius: 10px;
    background-color: rgb(246, 186, 119);
  }

  .editTextFour {
    padding: 6px;
    border: #cce4fc 1px solid;
    border-radius: 10px;
    background-color: #cce4fc;
  }
  .formDefinedClass {
    width: 100% !important;
  }

  .formDefinedClass /deep/ .ivu-form-item-content {
    width: 100% !important;
  }

  .formDefinedClass /deep/ .ivu-input-type-textarea {
    height: auto !important;
  }
  .work_order_screen /deep/ .ivu-form-item {
    margin-bottom: 0px;
  }
  .work_order_screen /deep/  .el-tabs__content{
    overflow: visible;
  }
  .work_order_screen /deep/ .ivu-form-item-error .ivu-select-arrow {
    color: #808695;
  }

  .work_order_screen /deep/ .ivu-date-picker {
    display: block;
  }

  .work_order_screen /deep/ .el-cascader {
    display: block;
  }

  .work_order_screen /deep/ .ivu-form-item-error .ivu-select-selection {
    border: 1px solid #57a3f3;
    box-shadow: none;
  }

  .file_class /deep/ .ivu-form-item-label {
    width: 20% !important;
  }

  .work_order_screen /deep/ .ivu-form-item-error .ivu-input {
    border: 1px solid #57a3f3;
    box-shadow: none;
  }

  .work_order_screen /deep/ .el-select{
    width: 100%;
    box-sizing: border-box;
    vertical-align: middle;
    color: #515a6e;
    font-size: 14px;
    line-height: normal;
  }
  .work_order_screen /deep/ .el-input--suffix .el-input__inner{
    height: 32px;
  }
  .work_order_screen /deep/ .el-input__icon{
    line-height: 32px;
  }
  #themeInput /deep/ .ivu-input{
    text-align: center;
  }

  .rightOneButtom{
    padding-left:5%;
    padding-right:5%;
    overflow-y: auto;
    background-color: rgb(250,251,253);
  }
  #jumpInput /deep/ .ivu-input{
    width: 50px;
  }

  #replyDiv /deep/ .ivu-table td{
    border-bottom:0px !important;
    height:25px !important;
  }
 #replyDiv /deep/  .ivu-table-wrapper {
    position: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/loginHeadMange/TelephoneScreen.vue